webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  api_url: 'https://api.strix.com.ar',
  api_username: '',
  default_password: '',
  google_key: 'AIzaSyD97borLfyeAMcfhI8flD3h821OcTfM_BI',
  nominatim_url: 'http://clnominatim01.lojackhq.com.ar/nominatim',
  clickgo_url: 'https://map.strix.com.ar/GeoReferencia2/GRService.svc/GetGeoRefByCoords',
  clickgo_token: '0E335347-54EB-4181-A0CB-30BF086BFC82'
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(120);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _utils = __webpack_require__(16);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThingsService = {

  create: function create(thing) {
    var create_request = function create_request() {
      console.log('creating thing: ' + (0, _stringify2.default)(thing, undefined, 2));
      return _vue2.default.http.post(_config2.default.apiUrl() + '/things/', thing);
    };
    return _utils2.default.generic_request(create_request);
  },

  fetch: function fetch(thingId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _utils2.default.generic_request(function () {
      console.log('fetching thing: ' + (0, _stringify2.default)(thingId, undefined, 2));
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thingId, { params: params });
    });
  },

  fetchLatestSignal: function fetchLatestSignal(thingId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _utils2.default.generic_request(function () {
      console.log('fetching thing latest signal: ' + (0, _stringify2.default)(thingId, undefined, 2));
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thingId + '/signals/latest', { params: params });
    });
  },

  attach: function attach(parentThingId, childThingId) {
    var attach_request = function attach_request() {
      console.log('attaching childThingId: ' + childThingId + ' to parentThingId: ' + parentThingId);
      var child_attach_json = {
        id: childThingId
      };
      return _vue2.default.http.post(_config2.default.apiUrl() + "/things/" + parentThingId + "/things/", child_attach_json);
    };
    return _utils2.default.generic_request(attach_request);
  },

  patch: function patch(thingId, changeSet) {
    var patch_request = function patch_request() {
      console.log('updating thing: ' + (0, _stringify2.default)(thingId, undefined, 2));
      return _vue2.default.http.patch(_config2.default.apiUrl() + '/things/' + thingId + '/info', changeSet);
    };
    return _utils2.default.generic_request(patch_request);
  },

  delete: function _delete(thingId) {
    var delete_request = function delete_request() {
      console.log('deleting thing: ' + (0, _stringify2.default)(thingId, undefined, 2));
      return _vue2.default.http.delete(_config2.default.apiUrl() + '/things/' + thingId);
    };
    return _utils2.default.generic_request(delete_request);
  },

  findAccountThings: function findAccountThings(account_id) {
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var find_account_things_request = function find_account_things_request() {
      console.log('findAccountThings account_id: ' + account_id);
      var _parameters = (0, _assign2.default)({ account_id: account_id }, parameters);
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things', { params: _parameters });
    };
    return _utils2.default.generic_request(find_account_things_request);
  },

  thingLocations: function thingLocations(thing_id, limit, page) {
    var things_locations_request = function things_locations_request() {
      console.log('Find Locations for thing: ' + thing_id);
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thing_id + '/locations?_limit=' + limit + '&_page=' + page);
    };
    return _utils2.default.generic_request(things_locations_request);
  },

  thingSignals: function thingSignals(thingId, parameters) {
    return _utils2.default.generic_request(function () {
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thingId + '/signals', { params: parameters });
    });
  },

  cleanAllThings: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(account_id) {
      var clean_all_things_request;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              clean_all_things_request = function () {
                var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                  var allthings;
                  return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _vue2.default.http.get(_config2.default.apiUrl() + '/things?account_id=' + account_id);

                        case 2:
                          allthings = _context2.sent;

                          allthings.body.map(function () {
                            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(thing) {
                              var deleteResponse;
                              return _regenerator2.default.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return _vue2.default.http.delete(_config2.default.apiUrl() + '/things/' + thing.id);

                                    case 2:
                                      deleteResponse = _context.sent;

                                    case 3:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              }, _callee, undefined);
                            }));

                            return function (_x5) {
                              return _ref3.apply(this, arguments);
                            };
                          }());

                        case 4:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, undefined);
                }));

                return function clean_all_things_request() {
                  return _ref2.apply(this, arguments);
                };
              }();

              return _context3.abrupt('return', _utils2.default.generic_request(clean_all_things_request));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function cleanAllThings(_x4) {
      return _ref.apply(this, arguments);
    };
  }(),

  findVehiculeByDomain: function findVehiculeByDomain(domain) {
    var find_vehicle_by_domain_request = function find_vehicle_by_domain_request() {
      var domainSerach = domain.toUpperCase();
      console.log('find cars by domain ' + domainSerach);
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/?_include=child_things&info.domain=' + domainSerach);
    };
    return _utils2.default.generic_request(find_vehicle_by_domain_request);
  },

  findVehiculeBySerial: function findVehiculeBySerial(serial) {
    return _utils2.default.generic_request((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
      var gpsResult, vehicleResult;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _vue2.default.http.get(_config2.default.apiUrl() + '/things/?_include=child_things&info.serial_number=' + serial);

            case 2:
              gpsResult = _context4.sent;

              if (!(gpsResult.body.length > 0)) {
                _context4.next = 8;
                break;
              }

              _context4.next = 6;
              return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + gpsResult.data[0].parent_id + '?_include=child_things');

            case 6:
              vehicleResult = _context4.sent;
              return _context4.abrupt('return', vehicleResult.body);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    })));
  },

  getActions: function getActions(thingId, query) {
    return _utils2.default.generic_request(function () {
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thingId + '/actions/?_q=' + query).then(function (x) {
        return x.body;
      });
    });
  },

  getAction: function getAction(thingId, executionId) {
    return _utils2.default.generic_request(function () {
      return _vue2.default.http.get(_config2.default.apiUrl() + '/things/' + thingId + '/actions/' + executionId).then(function (response) {
        return response.data;
      });
    });
  },

  executeAction: function executeAction(thingId, actionType) {
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _utils2.default.generic_request(function () {
      return _vue2.default.http.post(_config2.default.apiUrl() + '/things/' + thingId + '/actions/' + actionType, body).then(function (response) {
        return response.body;
      });
    });
  }
};
exports.default = ThingsService;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trunc = __webpack_require__(31);

var _trunc2 = _interopRequireDefault(_trunc);

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _authService = __webpack_require__(29);

var _authService2 = _interopRequireDefault(_authService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatDateOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
};

var Utils = {
  generic_request: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(request) {
      var response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return request();

            case 3:
              response = _context.sent;
              return _context.abrupt('return', response);

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              if (!(_context.t0.status !== undefined && _context.t0.status === 401)) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return _authService2.default.refreshToken();

            case 12:
              return _context.abrupt('return', request());

            case 15:
              throw _context.t0;

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 7]]);
    }));

    return function generic_request(_x) {
      return _ref.apply(this, arguments);
    };
  }(),

  getTimeDifference: function getTimeDifference(eventTimestamp) {
    var then = new Date(eventTimestamp);
    var now = new Date();
    var difference = (0, _trunc2.default)(Math.abs((now.getTime() - then.getTime()) / 1000));

    var hours = (0, _trunc2.default)(difference / 3600);
    var minutes = (0, _trunc2.default)(difference % 3600 / 60);
    var seconds = (0, _trunc2.default)(difference % 3600 % 60);

    return hours + ' hora(s) ' + minutes + ' minuto(s) ' + seconds + ' segundo(s)';
  },
  formatDatetime: function formatDatetime(datetime) {
    return new Date(datetime).toLocaleDateString('es-ES', formatDateOptions);
  }
};

exports.default = Utils;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _server_config = __webpack_require__(14);

var _server_config2 = _interopRequireDefault(_server_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  apiUrl: function apiUrl() {
    return _server_config2.default.api_url;
  },
  defaultUsername: function defaultUsername() {
    return _server_config2.default.api_username;
  },
  defaultPassword: function defaultPassword() {
    return _server_config2.default.default_password;
  }
};

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(18);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _utils = __webpack_require__(16);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountService = {

  create: function create(account) {
    var create_request = function create_request() {
      return _vue2.default.http.post(_config2.default.apiUrl() + '/services/accounts/create', account);
    };
    return _utils2.default.generic_request(create_request);
  },

  patch: function patch(id, changeSet) {
    var patch_request = function patch_request() {
      return _vue2.default.http.patch(_config2.default.apiUrl() + '/accounts/' + id, changeSet);
    };
    return _utils2.default.generic_request(patch_request);
  },

  findById: function findById(id) {
    var find_by_id_request = function find_by_id_request() {
      return _vue2.default.http.get(_config2.default.apiUrl() + '/accounts/' + id);
    };
    return _utils2.default.generic_request(find_by_id_request);
  },

  isEmpty: function isEmpty(value) {
    return value == '' || value == undefined;
  },

  verifyUsername: function verifyUsername(username) {
    var verify_username_request = function verify_username_request() {
      return _vue2.default.http.get(_config2.default.apiUrl() + '/services/users/check_username?username=' + escape(username));
    };
    return _utils2.default.generic_request(verify_username_request);
  },

  find: function find(searchCriteria) {
    var find_request = function find_request() {
      var url = _config2.default.apiUrl() + '/accounts?';
      var keys = (0, _keys2.default)(searchCriteria);
      keys.forEach(function (key) {
        url += key + '=' + searchCriteria[key] + '&';
      });
      console.log('find Account: ' + url);
      return _vue2.default.http.get(url);
    };
    return _utils2.default.generic_request(find_request);
  }

};
exports.default = AccountService;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _routesPaths = __webpack_require__(51);

var _routesPaths2 = _interopRequireDefault(_routesPaths);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthService = function () {
  function AuthService(apiUrl) {
    (0, _classCallCheck3.default)(this, AuthService);
    this._authBase64Data = null;
    this._requestPath = '/oauth';
    this._currentAccessToken = null;
    this._currentRefreshToken = null;

    this._apiUrl = apiUrl;
  }

  (0, _createClass3.default)(AuthService, [{
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      return this._currentAccessToken !== null && !this._tokenExpired();
    }
  }, {
    key: 'logout',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.revokeToken();

              case 2:
                this._setAuthentication(null);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logout() {
        return _ref.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: 'login',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(username, password) {
        var response;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._authBase64Data = btoa(username + ':' + password);
                _context2.next = 3;
                return _vue2.default.http.post('' + this._apiUrl + this._requestPath + '/token', 'grant_type=client_credentials&scope=all', { headers: this._getAuthenticationHeaders(this._authBase64Data) });

              case 3:
                response = _context2.sent;


                this._setAuthentication(response.body);
                return _context2.abrupt('return', response.body);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: 'refreshToken',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var responseRefreshToken;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _vue2.default.http.post('' + this._apiUrl + this._requestPath + '/token', 'grant_type=refresh_token&refresh_token=' + this._currentRefreshToken, { headers: this._getAuthenticationHeaders(this._authBase64Data) });

              case 2:
                responseRefreshToken = _context3.sent;

                this._setAuthentication(responseRefreshToken.body);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refreshToken() {
        return _ref3.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: 'revokeToken',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _vue2.default.http.post('' + this._apiUrl + this._requestPath + '/revoke', 'token=' + this._currentRefreshToken + '&token_type_hint=refresh_token', { headers: this._getAuthenticationHeaders(this._authBase64Data) });

              case 3:
                _context4.next = 9;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);
                console.log('Sesion Finalizada');

              case 9:
                _context4.prev = 9;

                this._unsetAuthentication();
                return _context4.finish(9);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5, 9, 12]]);
      }));

      function revokeToken() {
        return _ref4.apply(this, arguments);
      }

      return revokeToken;
    }()
  }, {
    key: 'redirectToLoginIfNeeded',
    value: function redirectToLoginIfNeeded(router) {
      this._restoreAuthentication();
      if (!this.isAuthenticated()) {
        alert('Su sesión ha expirado.');
        router.push(_routesPaths2.default.Login);
      }
    }
  }, {
    key: '_tokenExpired',
    value: function _tokenExpired() {
      var now = new Date().getTime();
      var expirationTime = localStorage.getItem(AuthService.TOKEN_EXPIRATION_TIME);
      return expirationTime == null || now >= expirationTime;
    }
  }, {
    key: '_setAuthentication',
    value: function _setAuthentication(authentication) {
      this._setupHeaders(authentication.access_token);
      var expirationTime = new Date().getTime() + authentication.expires_in * 1000;

      this._currentAccessToken = authentication.access_token;
      this._currentRefreshToken = authentication.refresh_token;
      localStorage.setItem(AuthService.ACCESS_TOKEN, authentication.access_token);
      localStorage.setItem(AuthService.REFRESH_TOKEN, authentication.refresh_token);
      localStorage.setItem(AuthService.TOKEN_EXPIRATION_TIME, expirationTime);
    }
  }, {
    key: '_unsetAuthentication',
    value: function _unsetAuthentication() {
      this._currentAccessToken = null;
      this._currentRefreshToken = null;
      localStorage.removeItem(AuthService.ACCESS_TOKEN);
      localStorage.removeItem(AuthService.REFRESH_TOKEN);
      localStorage.removeItem(AuthService.TOKEN_EXPIRATION_TIME);
    }
  }, {
    key: '_getAuthenticationHeaders',
    value: function _getAuthenticationHeaders(authBase64Data) {
      return {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Basic ' + authBase64Data
      };
    }
  }, {
    key: '_restoreAuthentication',
    value: function _restoreAuthentication() {
      if (this._tokenExpired()) {
        return;
      }

      var accessToken = localStorage.getItem(AuthService.ACCESS_TOKEN);
      var refreshToken = localStorage.getItem(AuthService.REFRESH_TOKEN);
      if (accessToken != null) {
        this._currentAccessToken = accessToken;
        this._currentRefreshToken = refreshToken;
        this._setupHeaders(accessToken);
      }
    }
  }, {
    key: '_setupHeaders',
    value: function _setupHeaders(accessToken) {
      _vue2.default.http.headers.common['Authorization'] = 'Bearer ' + accessToken;
      _vue2.default.http.headers.common['Accept'] = 'application/json; charset=utf-8';
      _vue2.default.http.headers.common['Content-Type'] = 'application/json';
    }
  }]);
  return AuthService;
}();

AuthService.ACCESS_TOKEN = 'ACCESS_TOKEN';
AuthService.REFRESH_TOKEN = 'REFRESH_TOKEN';
AuthService.TOKEN_EXPIRATION_TIME = 'TOKEN_EXPIRATION_TIME';


var auth = new AuthService(_config2.default.apiUrl());
exports.default = auth;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseGeocodeService = function () {
  function BaseGeocodeService() {
    (0, _classCallCheck3.default)(this, BaseGeocodeService);
  }

  (0, _createClass3.default)(BaseGeocodeService, [{
    key: 'reverseGeocode',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(latitude, longitude) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('Not implemented.');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reverseGeocode(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return reverseGeocode;
    }()
  }]);
  return BaseGeocodeService;
}();

exports.default = BaseGeocodeService;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _freeze = __webpack_require__(17);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IdentificationTypes = (0, _freeze2.default)({
    dni: 'DNI',
    cuit: 'CUIT',
    cuil: 'CUIL',
    le: 'LE',
    lc: 'LC',
    pasaporte: 'PASAPORTE'
});

exports.default = IdentificationTypes;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentificationTypes = exports.VehicleAction = exports.ThingActionState = undefined;

var _thing_action_state = __webpack_require__(109);

var _thing_action_state2 = _interopRequireDefault(_thing_action_state);

var _vehicle_action = __webpack_require__(110);

var _vehicle_action2 = _interopRequireDefault(_vehicle_action);

var _identification_types = __webpack_require__(48);

var _identification_types2 = _interopRequireDefault(_identification_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThingActionState = _thing_action_state2.default;
exports.VehicleAction = _vehicle_action2.default;
exports.IdentificationTypes = _identification_types2.default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperties = __webpack_require__(121);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Address = function () {
  function Address(builder) {
    (0, _classCallCheck3.default)(this, Address);

    (0, _defineProperties2.default)(this, {
      number: {
        value: builder.number,
        writable: false
      },
      street: {
        value: builder.street,
        writable: false
      },
      neighbourhood: {
        value: builder.neighbourhood,
        writable: false
      },
      city: {
        value: builder.city,
        writable: false
      },
      state: {
        value: builder.state,
        writable: false
      },
      country: {
        value: builder.country,
        writable: false
      },
      fullAddress: {
        value: builder.fullAddress,
        writable: false
      }
    });
  }

  (0, _createClass3.default)(Address, [{
    key: 'toString',
    value: function toString() {
      return this.fullAddress ? this.fullAddress : (this.street ? '' + this.street + (this.number ? ' ' + this.number : '') : '') + (this.neighbourhood ? ', ' + this.neighbourhood : '') + (this.city ? ', ' + this.city : '') + (this.state ? ', ' + this.state : '') + (this.country ? ', ' + this.country : '');
    }
  }], [{
    key: 'Builder',
    get: function get() {
      return Builder;
    }
  }]);
  return Address;
}();

var Builder = function () {
  function Builder() {
    (0, _classCallCheck3.default)(this, Builder);
  }

  (0, _createClass3.default)(Builder, [{
    key: 'setNumber',
    value: function setNumber(val) {
      this.number = val;
      return this;
    }
  }, {
    key: 'setStreet',
    value: function setStreet(val) {
      this.street = val;
      return this;
    }
  }, {
    key: 'setNeighbourhood',
    value: function setNeighbourhood(val) {
      this.neighbourhood = val;
      return this;
    }
  }, {
    key: 'setCity',
    value: function setCity(val) {
      this.city = val;
      return this;
    }
  }, {
    key: 'setState',
    value: function setState(val) {
      this.state = val;
      return this;
    }
  }, {
    key: 'setCountry',
    value: function setCountry(val) {
      this.country = val;
      return this;
    }
  }, {
    key: 'setFullAddress',
    value: function setFullAddress(val) {
      this.fullAddress = val;
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      return new Address(this);
    }
  }]);
  return Builder;
}();

exports.default = Address;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var Login = '/auth/login';
var Admin = '/admin';

var Main = Admin + '/main';

exports.default = {
  Login: Login,
  Main: Main
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(17);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeocodeProvider = (0, _freeze2.default)({
  ClickGo: 'clickgo',
  Nominatim: 'nominatim'
});

exports.default = GeocodeProvider;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeocodeProvider = undefined;

var _geocodeService = __webpack_require__(115);

var _geocodeService2 = _interopRequireDefault(_geocodeService);

var _geocodeProvider = __webpack_require__(52);

var _geocodeProvider2 = _interopRequireDefault(_geocodeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GeocodeProvider = _geocodeProvider2.default;
exports.default = _geocodeService2.default;

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formGroupInput = __webpack_require__(230);

var _formGroupInput2 = _interopRequireDefault(_formGroupInput);

var _Dropdown = __webpack_require__(226);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _formGroupInputValidate = __webpack_require__(231);

var _formGroupInputValidate2 = _interopRequireDefault(_formGroupInputValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', _formGroupInput2.default);
    Vue.component('drop-down', _Dropdown2.default);
    Vue.component('fg-input-validate', _formGroupInputValidate2.default);
  }
};

exports.default = GlobalComponents;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueClickaway = __webpack_require__(212);

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', _vueClickaway.directive);
  }
};

exports.default = GlobalDirectives;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalMixins = {
  install: function install(Vue) {
    Vue.mixin({
      mounted: function mounted() {
        var _this = this;

        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 269)).then(function () {
                    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee($) {
                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              window.jQuery = window.$ = $;
                              _context.next = 3;
                              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 268));

                            case 3:
                              $.material.init();

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }))();
      }
    });
  }
};

exports.default = GlobalMixins;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotFoundPage = __webpack_require__(216);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _TrackCar = __webpack_require__(224);

var _TrackCar2 = _interopRequireDefault(_TrackCar);

var _Login = __webpack_require__(215);

var _Login2 = _interopRequireDefault(_Login);

var _routesPaths = __webpack_require__(51);

var _routesPaths2 = _interopRequireDefault(_routesPaths);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: '/',
  component: _Login2.default,
  redirect: _routesPaths2.default.Login
}, {
  path: _routesPaths2.default.Login,
  component: _Login2.default
}, {
  path: _routesPaths2.default.Main,
  component: _TrackCar2.default
}, { path: '*', component: _NotFoundPage2.default }];

exports.default = routes;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(18);

var _keys2 = _interopRequireDefault(_keys);

var _trunc = __webpack_require__(31);

var _trunc2 = _interopRequireDefault(_trunc);

var _googleMaps = __webpack_require__(45);

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _server_config = __webpack_require__(14);

var _server_config2 = _interopRequireDefault(_server_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      myMap: null,
      normalMapSize: true,
      allMarkers: {},
      focusedMarker: null,
      currentSignals: this.signals,
      lastCarLocationMarker: null,
      mainMarkerImg: 'http://maps.google.com/mapfiles/kml/paddle/red-square.png',
      markerImgCommon: 'http://maps.google.com/mapfiles/kml/paddle/wht-stars.png',
      markerImgPined: 'http://maps.google.com/mapfiles/kml/pushpin/wht-pushpin.png',
      lastLocation: 'http://maps.google.com/mapfiles/kml/paddle/grn-stars.png',
      mainMarker: new google.maps.Marker()
    };
  },


  props: {
    lastCarLocation: null,
    signals: null,
    markerFocused: null,
    freshSignals: null
  },

  methods: {
    handleResize: function handleResize(event) {
      this.normalMapSize = document.documentElement.clientWidth > 991 ? true : false;
    },
    getLastPosition: function getLastPosition() {
      var lat = void 0;
      var lng = void 0;
      if (this.currentSignals.length === 0) {
        lat = -34.508657;
        lng = -58.517124;
      } else {
        lat = this.currentSignals[0].latitude;
        lng = this.currentSignals[0].longitude;
      }
      return new google.maps.LatLng(lat, lng);
    },
    getTimeDifference: function getTimeDifference(event_timestamp) {
      var then = new Date(event_timestamp);
      var now = new Date();
      var difference = (0, _trunc2.default)(Math.abs((now.getTime() - then.getTime()) / 1000));

      var hours = (0, _trunc2.default)(difference / 3600);
      var minutes = (0, _trunc2.default)(difference % 3600 / 60);
      var seconds = (0, _trunc2.default)(difference % 3600 % 60);

      return hours + ' hora(s) ' + minutes + ' minuto(s) ' + seconds + ' segundo(s)';
    },
    focusMarker: function focusMarker(id) {
      this.focusedMarker = id;
      this.myMap.setCenter(this.allMarkers[id].getPosition());
      if (this.allMarkers[id] !== this.mainMarker) {
        google.maps.event.trigger(this.allMarkers[id], 'show-data');
      }
    },
    unfocusMarker: function unfocusMarker() {
      if (this.allMarkers[this.focusedMarker] !== this.mainMarker) {
        google.maps.event.trigger(this.allMarkers[this.focusedMarker], 'hide-data');
      }
    },
    initMap: function initMap(google) {
      var _this = this;

      var myLatlng = this.getLastPosition();
      var mapOptions = {
        zoom: 10,
        center: myLatlng,

        gestureHandling: 'cooperative',
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]

      };
      var map = new google.maps.Map(document.getElementById('map'), mapOptions);
      this.myMap = map;

      this.setLastLocationMarker();

      this.currentSignals.map(function (element, index) {
        var infoWindow = new google.maps.InfoWindow({
          content: _this.getInfowindowText(element)
        });

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(_this.currentSignals[index].latitude, _this.currentSignals[index].longitude),
          title: _this.currentSignals[index].address,
          animation: google.maps.Animation.DROP,
          icon: _this.lastLocation,
          map: null
        });

        if (index === 0) {
          _this.mainMarker = marker;
          _this.mainMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
          _this.mainMarker.setMap(map);
          _this.mainInfoWindow = infoWindow;
          _this.setListenerOpen(_this.mainMarker, _this.mainInfoWindow, 'show-data-main');
          _this.setListenerClose(_this.mainMarker, _this.mainInfoWindow, 'hide-data-main');
          _this.mainMarker.setIcon(_this.mainMarkerImg);
          google.maps.event.trigger(_this.mainMarker, 'show-data-main');
        } else {
          _this.setCommonMarker(marker, infoWindow);
        }

        _this.allMarkers[element.index] = marker;
      });
    },
    agregateMarkers: function agregateMarkers(signals) {
      var _this2 = this;

      signals.map(function (element, index) {
        if (!_this2.allMarkers.hasOwnProperty(element.index)) {

          var map = _this2.myMap;

          var infoWindow = new google.maps.InfoWindow({
            content: _this2.getInfowindowText(element)
          });

          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(signals[index].latitude, signals[index].longitude),
            title: signals[index].address,
            animation: google.maps.Animation.DROP,
            icon: _this2.markerImgCommon,
            map: null
          });

          if (index === 0) {

            google.maps.event.trigger(_this2.mainMarker, 'hide-data-main');
            _this2.mainMarker.setIcon(_this2.markerImgCommon);
            _this2.mainMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

            _this2.setCommonMarker(_this2.mainMarker, _this2.mainInfoWindow);

            _this2.mainMarker = marker;
            _this2.mainMarker.setMap(map);
            _this2.mainInfoWindow = infoWindow;
            _this2.setListenerOpen(_this2.mainMarker, infoWindow, 'show-data-main');
            _this2.setListenerClose(_this2.mainMarker, infoWindow, 'hide-data-main');
            _this2.mainMarker.setIcon(_this2.mainMarkerImg);
            google.maps.event.trigger(_this2.mainMarker, 'show-data-main');
          } else {
            _this2.setCommonMarker(marker, infoWindow);
          }

          _this2.allMarkers[element.index] = marker;
        }
      });
    },
    setLastLocationMarker: function setLastLocationMarker() {
      if (this.lastCarLocation != null && this.myMap != null) {
        var position = new google.maps.LatLng(this.lastCarLocation.location.latitude, this.lastCarLocation.location.longitude);
        this.lastCarLocationMarker = new google.maps.Marker({
          position: position,
          title: "Ultima ubicación",
          animation: google.maps.Animation.DROP,
          icon: this.lastLocation,
          map: this.myMap
        });
        if (this.signals == null || this.signals.length === 0) {
          this.myMap.panTo(position);
        }
      }
    },
    setCommonMarker: function setCommonMarker(marker, infoWindow) {
      this.setListenerOpen(marker, infoWindow, 'show-data', this.markerImgCommon);
      this.setListenerClose(marker, infoWindow, 'hide-data');
    },
    setListenerOpen: function setListenerOpen(marker, infoWindow, event) {
      var _this3 = this;

      var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      marker.addListener(event, function () {
        if (marker !== _this3.mainMarker || marker === _this3.mainMarker && event === 'show-data-main') {
          infoWindow.open(_this3.myMap, marker);
          if (marker !== _this3.mainMarker) {
            marker.setMap(_this3.myMap);
          }
          if (icon !== null) {
            marker.setIcon(icon);
          }
        }
      });
    },
    setListenerClose: function setListenerClose(marker, infoWindow, event) {
      var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      marker.addListener(event, function () {
        if (marker !== this.mainMarker || marker === this.mainMarker && event === 'hide-data-main') {
          infoWindow.close(this.myMap, marker);
          if (marker !== this.mainMarker) {
            marker.setMap(null);
          }
          if (icon !== null) {
            marker.setIcon(icon);
          }
        }
      });
    },
    deleteMarkers: function deleteMarkers(newSignals) {
      var _this4 = this;

      var keys = (0, _keys2.default)(this.allMarkers);
      keys.map(function (key) {
        if (newSignals.every(function (signal) {
          signal.index !== key;
        })) {
          _this4.allMarkers[key].setMap(null);
          delete _this4.allMarkers[key];
        }
      });
    },
    getInfowindowText: function getInfowindowText(element) {
      return '\n        <b>Direcci\xF3n</b>: ' + element.address + '<br>\n        <b>Fecha y hora</b>: ' + element.datetime + '<br>\n        <b>Hace</b>: ' + this.getTimeDifference(element.event_timestamp);
    }
  },

  mounted: function mounted() {
    var _this5 = this;

    _googleMaps2.default.KEY = _server_config2.default.key;
    _googleMaps2.default.load(function (google) {
      _this5.initMap(google);
    });
    this.$nextTick(function () {
      window.addEventListener('resize', _this5.handleResize);
      _this5.handleResize();
    });
  },


  watch: {
    markerFocused: function markerFocused(id) {
      this.unfocusMarker();
      this.focusMarker(id);
    },
    signals: function signals(val) {
      this.agregateMarkers(val);
      setTimeout(this.$forceUpdate, 500);
    },
    freshSignals: function freshSignals(val) {
      this.deleteMarkers(val);
      this.agregateMarkers(val);
      setTimeout(this.$forceUpdate, 500);
    },
    lastCarLocation: function lastCarLocation(val) {
      if (this.lastCarLocationMarker != null && this.myMap != null) {
        this.lastCarLocationMarker.setMap(null);
      }
      if (val != null) {
        this.setLastLocationMarker();
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    editable: null,
    gps: null,
    flex: null
  },
  created: function created() {
    if (this.editable) {
      this.ddTitleMake = 'Queclink';
      this.ddTitleModel = this.queclinkModels[0];
      this.gps.make = 'Queclink';
      this.gps.model = this.queclinkModels[0];
    }
    if (!this.editable) {
      this.ddTitleMake = this.gps.make;
      this.ddTitleModel = this.gps.model;
    }

    if (this.flex !== undefined) this.flex.tecnology = 'GPS';
  },
  data: function data() {
    return {
      ddTitleTec: 'GPS',
      ddTitleMake: '',
      ddTitleModel: '',
      queclinkModels: ['GL300', 'GV200', 'GV300', 'GL200', 'GV500', 'GV55'],
      calampModels: ['LMU2630', 'LMU2720', 'LMU200', 'LMU300', 'LMU3030']
    };
  },

  methods: {
    putTec: function putTec(newTitle) {
      if (this.flex !== undefined) {
        this.ddTitleTec = newTitle;
        this.flex.tecnology = newTitle;
      }
    },
    putMake: function putMake(newTitle) {
      this.ddTitleMake = newTitle;
      this.gps.make = newTitle;
    },
    putModel: function putModel(newTitle) {
      this.ddTitleModel = newTitle;
      this.gps.model = newTitle;
    },
    updateModel: function updateModel(make) {
      if (make === 'queclink') this.putModel(this.queclinkModels[0]);else if (make === 'calamp') this.putModel(this.calampModels[0]);
    },
    input_changed: function input_changed(key, has_error) {
      this.$emit('input-changed', key, has_error);
    }
  }
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _authService = __webpack_require__(29);

var _authService2 = _interopRequireDefault(_authService);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      username: _config2.default.defaultUsername(),
      password: _config2.default.defaultPassword(),
      error_message: null
    };
  },

  methods: {
    authenticate: function authenticate() {
      var _this = this;

      _authService2.default.login(this.username, this.password).then(function (responseOk) {
        _this.$router.push('/admin/main');
      }, function (responseError) {
        _this.handle_error(responseError);
      });
    },
    handle_error: function handle_error(responseError) {
      console.log('Error ' + (0, _stringify2.default)(responseError));
      this.error_message = 'Error inesperado, contacte al administrador';
      if (responseError.body.code === 'invalid_client') {
        this.error_message = 'Usuario/Clave Inválidos';
      }
    }
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },

  props: {
    car: null,
    account: null
  },

  methods: {
    input_changed: function input_changed(key, has_error) {
      this.$emit('input-changed', key, has_error);
    }
  }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(57);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _CarProps = __webpack_require__(217);

var _CarProps2 = _interopRequireDefault(_CarProps);

var _UserProps = __webpack_require__(225);

var _UserProps2 = _interopRequireDefault(_UserProps);

var _MagentaAddressForm = __webpack_require__(220);

var _MagentaAddressForm2 = _interopRequireDefault(_MagentaAddressForm);

var _LoaderModal = __webpack_require__(236);

var _LoaderModal2 = _interopRequireDefault(_LoaderModal);

var _GPSForm = __webpack_require__(214);

var _GPSForm2 = _interopRequireDefault(_GPSForm);

var _thingsService = __webpack_require__(15);

var _thingsService2 = _interopRequireDefault(_thingsService);

var _accountService = __webpack_require__(28);

var _accountService2 = _interopRequireDefault(_accountService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CarProps: _CarProps2.default,
    UserProps: _UserProps2.default,
    GPSForm: _GPSForm2.default,
    MagentaAddressForm: _MagentaAddressForm2.default,
    LoaderModal: _LoaderModal2.default
  },
  data: function data() {
    return {
      show: false,
      disabledGuardar: false,
      formErrors: {
        año: false,
        "codigo postal": false
      },
      error: null,
      showModal: false,
      modalWorking: true,
      errorOcurred: false,
      myCopyCar: JSON.parse((0, _stringify2.default)(this.car)),
      myCopyAccount: JSON.parse((0, _stringify2.default)(this.account))
    };
  },

  computed: {
    hasPhones: function hasPhones() {
      return this.account.phones !== null && this.account.phones !== undefined && this.account.phones.length > 0;
    }
  },

  props: {
    car: {
      type: Object,
      default: function _default() {
        return {
          info: {
            make: "",
            model: "",
            domain: "",
            year: "",
            color: "",
            engine_number: "",
            chassis_number: ""
          }
        };
      }
    },
    gps: null,
    account: null,
    errorGps: null
  },
  methods: {
    save: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var car_changed, account_changed;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.showModal = true;
                car_changed = this.carChanged();
                account_changed = this.accountChanged();

                if (!(!car_changed && !account_changed)) {
                  _context.next = 7;
                  break;
                }

                this.setFailure("No se realizaron cambios");
                _context.next = 13;
                break;

              case 7:
                if (!car_changed) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return this.changeCar();

              case 10:
                if (!account_changed) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return this.changeAccount();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _ref.apply(this, arguments);
      }

      return save;
    }(),

    closeSuccess: function closeSuccess() {
      this.modalWorking = true;
      this.showModal = false;
    },
    closeFailure: function closeFailure() {
      this.modalWorking = true;
      this.showModal = false;
    },
    setFailure: function setFailure(errorMessage) {
      this.error = errorMessage;
      this.modalWorking = false;
      this.errorOcurred = true;
    },
    setSuccess: function setSuccess() {
      this.modalWorking = false;
      this.errorOcurred = false;
    },


    showInstance: function showInstance() {
      this.show = !this.show;
    },
    input_changed: function input_changed(key, has_error) {
      this.formErrors[key] = has_error;
      this.validate();
    },
    validate: function validate() {
      var values = (0, _values2.default)(this.formErrors);
      var reducer = function reducer(acumm, current) {
        return acumm || current;
      };
      this.disabledGuardar = values.reduce(reducer, false);
    },
    carChanged: function carChanged() {
      return this.car.info.make !== this.myCopyCar.info.make || this.car.info.model !== this.myCopyCar.info.model || this.car.info.color !== this.myCopyCar.info.color;
    },
    changeCar: function changeCar() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var changeSet, response, faiureText;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                changeSet = [];

                _this.car.info.make !== _this.myCopyCar.info.make ? changeSet.push({
                  action: "update",
                  path: "/make",
                  value: _this.myCopyCar.info.make
                }) : null;
                _this.car.info.model !== _this.myCopyCar.info.model ? changeSet.push({
                  action: "update",
                  path: "/model",
                  value: _this.myCopyCar.info.model
                }) : null;
                _this.car.info.color !== _this.myCopyCar.info.color ? changeSet.push({
                  action: "update",
                  path: "/color",
                  value: _this.myCopyCar.info.color
                }) : null;

                if (!(changeSet.length > 0)) {
                  _context2.next = 18;
                  break;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return _thingsService2.default.patch(_this.car.id, changeSet);

              case 8:
                response = _context2.sent;

                _this.$emit("car-change", response.body);
                _this.setSuccess();
                _context2.next = 18;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](5);
                faiureText = "Error actualizando el vehículo. Reintente o contacte a un adminsitrador.";

                if (_context2.t0.body) faiureText = _context2.t0.body.description;
                _this.setFailure(faiureText);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[5, 13]]);
      }))();
    },
    accountChanged: function accountChanged() {
      return this.account.address.address_line1 !== this.myCopyAccount.address.address_line1 || this.account.address.address_line2 !== this.myCopyAccount.address.address_line2 || this.account.address.city !== this.myCopyAccount.address.city || this.account.address.country !== this.myCopyAccount.address.country || this.account.address.postal_code !== this.myCopyAccount.address.postal_code || this.account.address.state !== this.myCopyAccount.address.state;
    },
    changeAccount: function changeAccount() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var changeSet, response, faiureText;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                changeSet = [];

                _this2.account.address.address_line1 !== _this2.myCopyAccount.address.address_line1 ? changeSet.push({
                  action: "update",
                  path: "/address/address_line1",
                  value: _this2.myCopyAccount.address.address_line1
                }) : null;
                _this2.account.address.address_line2 !== _this2.myCopyAccount.address.address_line2 ? changeSet.push({
                  action: "update",
                  path: "/address/address_line2",
                  value: _this2.myCopyAccount.address.address_line2
                }) : null;
                _this2.account.address.city !== _this2.myCopyAccount.address.city ? changeSet.push({
                  action: "update",
                  path: "/address/city",
                  value: _this2.myCopyAccount.address.city
                }) : null;
                _this2.account.address.country !== _this2.myCopyAccount.address.country ? changeSet.push({
                  action: "update",
                  path: "/address/country",
                  value: _this2.myCopyAccount.address.country
                }) : null;
                _this2.account.address.postal_code !== _this2.myCopyAccount.address.postal_code ? changeSet.push({
                  action: "update",
                  path: "/address/postal_code",
                  value: _this2.myCopyAccount.address.postal_code
                }) : null;
                _this2.account.address.state !== _this2.myCopyAccount.address.state ? changeSet.push({
                  action: "update",
                  path: "/address/state",
                  value: _this2.myCopyAccount.address.state
                }) : null;

                if (!(changeSet.length > 0)) {
                  _context3.next = 21;
                  break;
                }

                _context3.prev = 8;
                _context3.next = 11;
                return _accountService2.default.patch(_this2.account.id, changeSet);

              case 11:
                response = _context3.sent;

                _this2.$emit("account-change", response.body);
                _this2.setSuccess();
                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](8);
                faiureText = "Error actualizando la cuenta. Reintente o contacte a un administrador.";

                if (_context3.t0.body) faiureText = _context3.t0.body.description;
                _this2.setFailure(faiureText);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[8, 16]]);
      }))();
    }
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(18);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(57);

var _values2 = _interopRequireDefault(_values);

var _defineProperty2 = __webpack_require__(122);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _geocodeProvidersName;

var _googleMaps = __webpack_require__(45);

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _vue2Datepicker = __webpack_require__(266);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _geocoding = __webpack_require__(53);

var _geocoding2 = _interopRequireDefault(_geocoding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var geocodeProvidersNames = (_geocodeProvidersName = {}, (0, _defineProperty3.default)(_geocodeProvidersName, _geocoding.GeocodeProvider.Google, "Google"), (0, _defineProperty3.default)(_geocodeProvidersName, _geocoding.GeocodeProvider.ClickGo, "ClickGo"), (0, _defineProperty3.default)(_geocodeProvidersName, _geocoding.GeocodeProvider.Nominatim, "Nominatim"), _geocodeProvidersName);

var geocodeProviders = (0, _values2.default)(_geocoding.GeocodeProvider).map(function (provider) {
  return {
    value: provider,
    name: provider in geocodeProvidersNames ? geocodeProvidersNames[provider] : provider
  };
});

exports.default = {
  components: {
    DatePicker: _vue2Datepicker2.default
  },

  props: {
    car: null,
    currentSignals: null,
    rowsPerPage: null
  },

  data: function data() {
    return {
      dateRange: [],
      selectedProvider: null,
      geocodeProviders: geocodeProviders,
      columnsValues: [{
        label: "Fecha y Hora",
        field: "datetime",
        sortable: false,
        tdClass: "text-center",
        width: "150px",
        placeholder: "Filtrar por fecha"
      }, {
        label: "Ubicación",
        field: "address",
        sortable: false,
        tdClass: "text-center",
        width: "200px",
        placeholder: "Filtrar por ubicación"
      }, {
        label: "Velocidad",
        sortable: false,
        field: "speed",
        type: "number",
        tdClass: "text-center",
        placeholder: "Filtrar por velocidad"
      }, {
        label: "Rumbo",
        sortable: false,
        field: this.heading_text,
        tdClass: "text-center",
        placeholder: "Filtrar por rumbo"
      }, {
        label: "Evento",
        sortable: false,
        field: this.event_text,
        tdClass: "text-center",
        placeholder: "Filtrar por evento"
      }, {
        label: "Online",
        sortable: false,
        field: this.online_text,
        tdClass: "online",
        placeholder: "Filtrar por estado"
      }, {
        label: "Antena",
        sortable: false,
        field: this.antenna_state_ok_text,
        tdClass: "text-center",
        placeholder: "Filtrar por estado de la antena"
      }],
      myGeocoder: null,
      mostrarDatos: false,
      data: this.currentSignals
    };
  },


  computed: {
    tableClass: function tableClass() {
      return "table-" + this.type;
    },
    isPlain: function isPlain() {
      return this.type === "plain";
    }
  },

  watch: {
    currentSignals: function currentSignals(val) {
      this.$forceUpdate();
    }
  },

  created: function created() {
    this.selectedProvider = _geocoding2.default.getProvider();
  },


  methods: {
    hasValue: function hasValue(item, column) {
      var aux = column.replace(/\s+/g, "");
      return item[aux.toLowerCase()] !== "undefined";
    },
    itemValue: function itemValue(item, column) {
      var aux = column.replace(/\s+/g, "");
      return item[aux.toLowerCase()];
    },
    showRow: function showRow(params) {
      this.$emit("focus-location", params.row.index);
    },
    pageChange: function pageChange(info) {
      this.$emit("page-change", info.currentPage);
    },


    online_text: function online_text(rowObj) {
      var minutes = Math.floor(rowObj.online_timestamp / 60);
      var seconds = rowObj.online_timestamp - minutes * 60;
      return minutes + ":" + Math.round(seconds);
    },

    antenna_state_ok_text: function antenna_state_ok_text(rowObj) {
      if (rowObj.antenna_state_ok) return "Ok";else return "COLGADA";
    },

    event_text: function event_text(rowObj) {
      switch (rowObj.event) {
        case "stationary_contact_off":
          return "Estacionado - Sin contacto";
          break;
        case "contact_on":
          return "En contacto";
          break;
        case "in_motion_contact_on":
          return "Movimiento - En contacto";
          break;
        case "motion_initiated":
          return "Movimiento iniciado";
          break;
        default:
          return rowObj.event;
      }
    },

    heading_text: function heading_text(rowObj) {
      var norte = [0, 22];
      var noreste = [23, 68];
      var este = [69, 112];
      var sureste = [113, 158];
      var sur = [159, 202];
      var suroeste = [203, 248];
      var oeste = [249, 292];
      var noroeste = [293, 337];
      var norte2 = [338, 360];
      var cardinal_points = {
        Norte: norte,
        "Norte ": norte2,
        Noreste: noreste,
        Este: este,
        Sureste: sureste,
        Sur: sur,
        Suroeste: suroeste,
        Oeste: oeste,
        Noroeste: noroeste
      };
      var result = " ";
      (0, _keys2.default)(cardinal_points).forEach(function (key) {
        if (cardinal_points[key][0] <= rowObj.heading && cardinal_points[key][1] >= rowObj.heading) {
          result = key;
        }
      });
      return result;
    },

    clearDates: function clearDates() {
      this.$emit("clear-dates");
    },
    datesChanged: function datesChanged(dates) {
      this.$emit("change-dates", dates[0], dates[1]);
    },
    onChangeGeocodingProvider: function onChangeGeocodingProvider(event) {
      this.$emit("change-geocode-provider", event.target.value);
    }
  }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    home: null,
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + (0, _stringify2.default)(this.address));
    },
    input_changed: function input_changed(key, has_error) {
      this.$emit('input-changed', key, has_error);
    }
  }
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    mapLink: {
      type: String,
      default: ""
    },
    showLink: {
      type: Boolean,
      defualt: false
    },
    copying: {
      type: Boolean,
      defualt: false
    }
  },

  methods: {
    enable_map_link: function enable_map_link() {
      this.$emit("enable-map-link");
    },

    onCopy: function onCopy() {
      return;
    },

    onError: function onError() {
      alert("Error al copiar a la papelera");
    }
  }
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TableCar = __webpack_require__(223);

var _TableCar2 = _interopRequireDefault(_TableCar);

var _ItemList = __webpack_require__(235);

var _ItemList2 = _interopRequireDefault(_ItemList);

var _accountService = __webpack_require__(28);

var _accountService2 = _interopRequireDefault(_accountService);

var _thingsService = __webpack_require__(15);

var _thingsService2 = _interopRequireDefault(_thingsService);

var _identification_types = __webpack_require__(48);

var _identification_types2 = _interopRequireDefault(_identification_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TableCar: _TableCar2.default,
    ItemList: _ItemList2.default
  },
  data: function data() {
    return {
      types: _identification_types2.default,
      disabledSearchDoc: true,
      disabledSearchDomain: true,
      disabledSearchSerial: true,
      ddTitleDoc: "DNI",
      docSearchCriteria: {
        identification_type: this.ddTitleDoc,
        identification_number: ""
      },
      show: true,
      domain: "",
      serial: "",
      searchResult: null,
      carSelected: null,
      tableColumnsTitles: ["Marca", "Modelo", "Dominio", "Motor", "Chasis", "Serial GPS"],
      tableColumnsValues: ["make", "model", "domain", "engine_number", "chassis_number", "gps_serial"]
    };
  },

  methods: {
    input_changed: function input_changed(key, has_error) {
      switch (key) {
        case "patente":
          this.disabledSearchDomain = has_error;
          break;
        case "número":
          this.disabledSearchDoc = has_error;
          break;
        case "serial":
          this.disabledSearchSerial = has_error;
          break;
      }
    },


    buscarDocumento: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var responseAccount, thingsParams, responseThings;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.reset_view();
                _context.prev = 1;
                _context.next = 4;
                return _accountService2.default.find(this.docSearchCriteria);

              case 4:
                responseAccount = _context.sent;

                this.searchResult = [];

                if (!(responseAccount.body.length > 0)) {
                  _context.next = 12;
                  break;
                }

                thingsParams = {
                  type: "mrn:things:vehicle",
                  _include: "child_things"
                };
                _context.next = 10;
                return _thingsService2.default.findAccountThings(responseAccount.body[0].id, thingsParams);

              case 10:
                responseThings = _context.sent;

                this.searchResult = responseThings.body.map(this.processCarResult);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                alert((0, _stringify2.default)(_context.t0, undefined, 2));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 14]]);
      }));

      function buscarDocumento() {
        return _ref.apply(this, arguments);
      }

      return buscarDocumento;
    }(),

    buscarPatente: function buscarPatente() {
      var _this = this;

      this.reset_view();
      _thingsService2.default.findVehiculeByDomain(this.domain).then(function (responseOk) {
        _this.searchResult = responseOk.body.map(_this.processCarResult);
      }, function (responseError) {
        console.log("Error al buscar vehiculo: " + _this.domain + " , " + (0, _stringify2.default)(responseError));
      });
    },

    searchSerial: function searchSerial() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var result;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.reset_view();
                _context2.prev = 1;
                _context2.next = 4;
                return _thingsService2.default.findVehiculeBySerial(_this2.serial);

              case 4:
                result = _context2.sent;

                _this2.searchResult = result != null ? [_this2.processCarResult(result)] : [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.log("Error al buscar vehiculo: " + _this2.serial + " , " + (0, _stringify2.default)(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    processCarResult: function processCarResult(result) {
      var gpsSerial = "No posee GPS";
      if (result.includes != null && result.includes.child_things != null) {
        var gps = result.includes.child_things.filter(function (x) {
          return x.type === "mrn:things:gps";
        });
        gpsSerial = gps.length > 0 ? gps[0].info.serial_number : "Error";
      }

      return {
        id: result.id,
        make: result.info.make,
        model: result.info.model,
        domain: result.info.domain,
        engine_number: result.info.engine_number,
        chassis_number: result.info.chassis_number,
        gps_serial: gpsSerial,
        thing: result
      };
    },


    showInstance: function showInstance() {
      this.show = !this.show;
    },
    reset_view: function reset_view() {
      this.$emit("reset-view");
    },
    onSelectChange: function onSelectChange(result) {
      this.$emit("input-changed", result.thing);

      this.carSelected = result.thing;
    },
    localizar: function localizar() {
      this.show = false;
      this.carSelected = null;
      this.$emit("localizar");
    },
    putDoc: function putDoc(newType) {
      this.ddTitleDoc = newType;
      this.docSearchCriteria.identification_type = newType;
    }
  },

  mounted: function mounted() {
    this.docSearchCriteria.identification_type = this.ddTitleDoc;
  },
  created: function created() {
    this.docSearchCriteria.identification_number = "";
    this.domain = "";
  }
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      columns: ['Index', 'Marca', 'Modelo', 'Dominio', 'Motor', 'Chasis', 'Servicio'],
      data: [{ index: 1, marca: 'Ford', modelo: 'Focus', dominio: 'AABB445', motor: 'V8-7431', chasis: 'CHA111', servicio: 'Recupero' }, { index: 2, marca: 'Ford', modelo: 'Focus', dominio: 'AABB445', motor: 'V8-7431', chasis: 'CHA111', servicio: 'Recupero' }],
      title: 'Vehículos encontrados',
      subTitle: '',
      filaSelect: null,
      show: false
    };
  },

  computed: {
    tableClass: function tableClass() {
      return 'table-' + this.type;
    },
    isPlain: function isPlain() {
      return this.type === 'plain';
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    localizar: function localizar() {
      alert((0, _stringify2.default)(this.filaSelect));
    }
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(18);

var _keys2 = _interopRequireDefault(_keys);

var _trunc = __webpack_require__(31);

var _trunc2 = _interopRequireDefault(_trunc);

var _promise = __webpack_require__(33);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _SearchCar = __webpack_require__(222);

var _SearchCar2 = _interopRequireDefault(_SearchCar);

var _ChangeCar = __webpack_require__(218);

var _ChangeCar2 = _interopRequireDefault(_ChangeCar);

var _LocationTable = __webpack_require__(219);

var _LocationTable2 = _interopRequireDefault(_LocationTable);

var _MapLink = __webpack_require__(221);

var _MapLink2 = _interopRequireDefault(_MapLink);

var _Maps = __webpack_require__(213);

var _Maps2 = _interopRequireDefault(_Maps);

var _LastPositionTable = __webpack_require__(232);

var _LastPositionTable2 = _interopRequireDefault(_LastPositionTable);

var _FuelCut = __webpack_require__(227);

var _FuelCut2 = _interopRequireDefault(_FuelCut);

var _FuelCutHistory = __webpack_require__(228);

var _FuelCutHistory2 = _interopRequireDefault(_FuelCutHistory);

var _Tabs = __webpack_require__(233);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _googleMaps = __webpack_require__(45);

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _server_config = __webpack_require__(14);

var _server_config2 = _interopRequireDefault(_server_config);

var _vueSimpleSpinner = __webpack_require__(47);

var _vueSimpleSpinner2 = _interopRequireDefault(_vueSimpleSpinner);

var _accountService = __webpack_require__(28);

var _accountService2 = _interopRequireDefault(_accountService);

var _thingsService = __webpack_require__(15);

var _thingsService2 = _interopRequireDefault(_thingsService);

var _authService = __webpack_require__(29);

var _authService2 = _interopRequireDefault(_authService);

var _services = __webpack_require__(118);

var _utils = __webpack_require__(16);

var _utils2 = _interopRequireDefault(_utils);

var _models = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DAYS_RANGE = 4.32e+8;exports.default = {
  components: {
    SearchCar: _SearchCar2.default,
    ChangeCar: _ChangeCar2.default,
    LocationTable: _LocationTable2.default,
    Spinner: _vueSimpleSpinner2.default,
    MapLink: _MapLink2.default,
    Maps: _Maps2.default,
    LastPositionTable: _LastPositionTable2.default,
    FuelCut: _FuelCut2.default,
    FuelCutHistory: _FuelCutHistory2.default,
    Tabs: _Tabs2.default
  },
  data: function data() {
    return {
      car: _models.Car.getNew(),
      gps: _models.Gps.getNew(),
      currentInterval: null,
      dateFrom: null,
      dateTo: null,
      lastSignalReported: null,
      lastPosition: null,
      account: {
        name: '',
        address: null
      },
      isProcessing: false,
      show_tracking: false,
      serverError: null,
      errorGps: false,
      currentSignals: [],
      markerToFocus: null,
      lastSignalTimestamp: null,
      freshSignals: null,

      rowsPerPageTrack: 15,
      currentPageTrack: 1,
      finalSignals: null,

      mapLink: '',
      showLink: false
    };
  },


  created: function created() {
    _authService2.default.redirectToLoginIfNeeded(this.$router);
    _googleMaps2.default.KEY = _server_config2.default.google_key;
    _googleMaps2.default.load();
  },

  methods: {
    update: function update() {
      alert((0, _stringify2.default)(this.currentSignals, undefined, 2));
    },
    selectCar: function selectCar(car) {
      this.car = car;
      this.show_tracking = false;
    },
    localizar_click: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearDates();
                this.currentPageTrack = 1;
                this.isProcessing = true;
                this.lastSignalReported = null;
                _context.next = 6;
                return this.get_car_gps();

              case 6:
                this.currentSignals = [];
                this.finalSignals = [];
                this.lastSignalTimestamp = null;
                this.setLastPosition();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function localizar_click() {
        return _ref.apply(this, arguments);
      }

      return localizar_click;
    }(),

    reset_view: function reset_view() {
      this.show_tracking = false;
      this.errorGps = false;
      this.car = _models.Car.getNew();
      this.gps = _models.Gps.getNew();
      this.cancelCurrentInterval();
    },

    add_fields: function add_fields(signals) {
      signals.forEach(function (element) {
        element.address = ' ';
        element.antenna_state_ok = false;
        element.online_timestamp = 0;
      });
    },

    getSignals: function getSignals() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this.find_user_from_car(_this.car);

              case 3:
                if (!(_this.dateFrom == null && _this.dateTo == null)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return _this.doFindSignals();

              case 6:
                _this.setSignalRefreshInterval();
                _context2.next = 13;
                break;

              case 9:
                _this.cancelCurrentInterval();
                _context2.next = 12;
                return _this.getSignalsRange();

              case 12:
                _this.currentSignals = _context2.sent;

              case 13:
                setTimeout(_this.now_show_tracking, 5000);
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);

                alert('getSignals catch: ' + (0, _stringify2.default)(_context2.t0, undefined, 2));
                setTimeout(_this.now_show_tracking, 5000);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 16]]);
      }))();
    },
    doFindSignals: function doFindSignals() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var partSignals;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.doGetSignals();

              case 2:
                partSignals = _context3.sent;

                partSignals.map(function (element, index) {
                  element.index = element.event_timestamp;
                });
                _this2.add_fields(partSignals);
                partSignals = _this2.filterDayDifference(partSignals);
                _this2.freshSignals = _this2.filterFreshSignals(partSignals);
                _context3.next = 9;
                return _promise2.default.all(_this2.freshSignals.map(_this2.complete_signal_json));

              case 9:
                _this2.currentSignals = _this2.freshSignals.concat(_this2.currentSignals);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    doGetSignals: function doGetSignals() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var now, lastSignal, to, parameters, response;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                now = Date.now();
                _context4.next = 3;
                return _this3.getLastSignalTimestamp();

              case 3:
                lastSignal = _context4.sent;

                if (lastSignal != null) _this3.lastSignalReported = lastSignal;

                to = _this3.lastSignalReported != null && _this3.lastSignalReported <= now ? _this3.lastSignalReported : now;
                parameters = {
                  _to: to,
                  _from: to - DAYS_RANGE,
                  _page: _this3.currentPageTrack,
                  _limit: _this3.rowsPerPageTrack
                };
                _context4.next = 9;
                return _thingsService2.default.thingSignals(_this3.car.id, parameters);

              case 9:
                response = _context4.sent;
                return _context4.abrupt('return', response.body);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getSignalsRange: function getSignalsRange() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var parameters, response;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                parameters = {
                  _to: _this4.dateTo,
                  _from: _this4.dateFrom,
                  _page: _this4.currentPageTrack,
                  _limit: _this4.rowsPerPageTrack
                };
                _context5.next = 3;
                return _thingsService2.default.thingSignals(_this4.car.id, parameters);

              case 3:
                response = _context5.sent.body;

                _this4.add_fields(response);
                response.map(function (element, index) {
                  element.index = element.event_timestamp;
                });
                _context5.next = 8;
                return _promise2.default.all(response.map(_this4.complete_signal_json));

              case 8:
                return _context5.abrupt('return', response);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    clearDates: function clearDates() {
      this.currentSignals = [];
      this.dateFrom = null;
      this.dateTo = null;
      this.lastSignalTimestamp = null;
      this.lastPosition = null, this.getSignals();
    },
    changeDates: function changeDates(dateFrom, dateTo) {
      this.currentSignals = [];
      this.dateFrom = dateFrom.getTime();

      this.dateTo = dateTo.getTime() + 8.64e+7;
      this.lastSignalTimestamp = null;
      this.getSignals();
    },
    cancelCurrentInterval: function cancelCurrentInterval() {
      if (this.currentInterval != null) {
        clearInterval(this.currentInterval);
      }
    },
    setSignalRefreshInterval: function setSignalRefreshInterval() {
      var _this5 = this;

      this.cancelCurrentInterval();
      this.currentInterval = setInterval((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this5.doFindSignals();

              case 2:
                return _context6.abrupt('return', _context6.sent);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      })), 5000);
    },
    filterDayDifference: function filterDayDifference(signals) {
      if (signals.length === 0) {
        return [];
      }
      var finalSignals = [];
      var first = new Date(signals[0].event_timestamp);
      for (var index = 0; index < signals.length; index++) {
        var current = new Date(signals[index].event_timestamp);
        var difference = (0, _trunc2.default)(Math.abs((first.getTime() - current.getTime()) / 1000));
        if (difference < 172800) {
          finalSignals.push(signals[index]);
        } else {
          break;
        }
      }
      return finalSignals;
    },
    filterFreshSignals: function filterFreshSignals(signals) {
      if (signals.length === 0) {
        return [];
      }
      var freshSignals = [];
      if (this.lastSignalTimestamp !== null) {
        for (var index = 0; index < signals.length; index++) {
          if (signals[index].event_timestamp > this.lastSignalTimestamp) {
            freshSignals.push(signals[index]);
          } else {
            break;
          }
        }
      } else {
        freshSignals = signals;
      }
      this.lastSignalTimestamp = signals[0].event_timestamp;
      return freshSignals;
    },


    now_show_tracking: function now_show_tracking() {
      this.isProcessing = false;
      this.show_tracking = true;
    },

    find_user_from_car: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(car) {
        var response;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _accountService2.default.findById(car.account_id);

              case 3:
                response = _context7.sent;

                this.account = response.body;
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);

                alert('getSignals catch: ' + (0, _stringify2.default)(_context7.t0, undefined, 2));

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function find_user_from_car(_x) {
        return _ref3.apply(this, arguments);
      }

      return find_user_from_car;
    }(),

    handle_error: function handle_error(error) {
      this.serverError = error;
    },

    get_car_gps: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
        var responseGps, failureText;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                this.lastSignalReported = this.car.metadata.state != null && this.car.metadata.state.location != null ? this.car.metadata.state.location.timestamp : null;

                if (!(this.car.things.length > 0)) {
                  _context8.next = 7;
                  break;
                }

                _context8.next = 5;
                return _thingsService2.default.fetch(this.car.things[0]);

              case 5:
                responseGps = _context8.sent;

                if (responseGps.body.type === 'mrn:things:gps') {
                  this.gps = responseGps.body;
                } else {
                  this.errorGps = true;
                }

              case 7:
                _context8.next = 15;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);
                failureText = 'Error buscando gps. Reintente o contacte al administrador.';

                if (_context8.t0.body) {
                  failureText = _context8.t0.body.description;
                }
                this.errorGps = true;
                this.handle_error({ body: { message: failureText } });

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function get_car_gps() {
        return _ref4.apply(this, arguments);
      }

      return get_car_gps;
    }(),

    complete_signal_json: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(signal_json, index) {
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(signal_json.address === ' ')) {
                  _context9.next = 3;
                  break;
                }

                _context9.next = 3;
                return this.coordinates_to_address(signal_json, index);

              case 3:
                if (signal_json.antenna_state_ok === false) {
                  this.antenna_state(signal_json);
                }
                if (signal_json.online_timestamp === 0) {
                  this.set_online(signal_json);
                }
                this.format_datetime(signal_json);

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function complete_signal_json(_x2, _x3) {
        return _ref5.apply(this, arguments);
      }

      return complete_signal_json;
    }(),

    format_datetime: function format_datetime(signal_json) {
      var options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
      var date = new Date(signal_json.event_timestamp);
      signal_json.datetime = date.toLocaleDateString('es-ES', options);
    },

    coordinates_to_address: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(signal_json, index) {
        var response;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return _services.GeocodeService.reverseGeocode(signal_json.latitude, signal_json.longitude);

              case 3:
                response = _context10.sent;

                signal_json.address = response != null ? '' + response : "Error al geocodificar la dirección";
                return _context10.abrupt('return', signal_json.address);

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10['catch'](0);

                console.log(_context10.t0);
                console.log('error geocode' + (0, _stringify2.default)(_context10.t0, undefined, 2));
                signal_json.address = "Error al geocodificar la dirección";
                return _context10.abrupt('return', signal_json.address);

              case 14:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function coordinates_to_address(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return coordinates_to_address;
    }(),

    antenna_state: function antenna_state(signal_json) {
      signal_json.antenna_state_ok = (signal_json.event_timestamp - signal_json.fix_timestamp) * 0.001 < 255;
    },

    set_online: function set_online(signal_json) {
      signal_json.online_timestamp = (signal_json.ingestion_timestamp - signal_json.event_timestamp) * 0.001;
    },

    coordinates_to_link: function coordinates_to_link(lat, lng) {
      return 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng;
    },

    enable_map_link: function enable_map_link() {
      var lat = this.currentSignals[0].latitude;
      var lng = this.currentSignals[0].longitude;
      this.mapLink = this.coordinates_to_link(lat, lng);
      this.showLink = true;
    },

    focusLocation: function focusLocation(id) {
      this.markerToFocus = id;
    },

    carChange: function carChange(newCar) {
      this.car = newCar;
      this.setLastPosition();
    },
    refreshCar: function refreshCar() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
        var response;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(_this6.car == null || _this6.car.id == null)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return');

              case 2:
                _context11.next = 4;
                return _thingsService2.default.fetch(_this6.car.id + '?_include=child_things');

              case 4:
                response = _context11.sent;

                _this6.car = response.body;
                _this6.setLastPosition();

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this6);
      }))();
    },
    setLastPosition: function setLastPosition() {
      var _this7 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
        var location;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                location = {
                  latitude: _this7.car.state.location.coordinates[0],
                  longitude: _this7.car.state.location.coordinates[1]
                };
                _context12.t0 = location;
                _context12.next = 5;
                return _this7.coordinates_to_address(location, 0);

              case 5:
                _context12.t1 = _context12.sent;
                _context12.t2 = _this7.car.metadata.state.location.timestamp;
                _this7.lastPosition = {
                  location: _context12.t0,
                  address: _context12.t1,
                  timestamp: _context12.t2
                };
                _context12.next = 13;
                break;

              case 10:
                _context12.prev = 10;
                _context12.t3 = _context12['catch'](0);

                console.error("Hubo un error obteniendo la ultima ubicacion del auto.");

              case 13:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this7, [[0, 10]]);
      }))();
    },
    accountChange: function accountChange(newAccount) {
      this.account = newAccount;
    },
    pageChange: function pageChange(newPage) {
      var _this8 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
        return _regenerator2.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this8.currentPageTrack = newPage;
                _this8.currentSignals = [];
                _this8.finalSignals = [];
                _this8.lastSignalTimestamp = null;
                _context13.next = 6;
                return _this8.getSignals();

              case 6:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this8);
      }))();
    },
    changeGeolocalizationProvider: function changeGeolocalizationProvider(provider) {
      var _this9 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _services.GeocodeService.setProvider(provider);
                _this9.isProcessing = true;
                _this9.currentSignals = [];
                _this9.finalSignals = [];
                _this9.lastSignalTimestamp = null;
                _context14.next = 7;
                return _this9.getSignals();

              case 7:
                _this9.isProcessing = false;
                console.log(provider);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this9);
      }))();
    },
    getLastSignalTimestamp: function getLastSignalTimestamp() {
      var _this10 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
        var lastSignal, _lastSignal;

        return _regenerator2.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                if (!(_this10.account.services != undefined && _this10.account.services['mrn:service:vehicle_lite'] != undefined)) {
                  _context15.next = 8;
                  break;
                }

                _context15.next = 4;
                return _thingsService2.default.fetchLatestSignal(_this10.car.id);

              case 4:
                lastSignal = _context15.sent;
                return _context15.abrupt('return', lastSignal != null ? lastSignal.body.event_timestamp : null);

              case 8:
                _context15.next = 10;
                return _thingsService2.default.fetch(_this10.car.id, { _p: 'metadata.state.location.timestamp' });

              case 10:
                _lastSignal = _context15.sent;
                return _context15.abrupt('return', _lastSignal != null ? _lastSignal.body.metadata.state.location.timestamp : null);

              case 12:
                _context15.next = 18;
                break;

              case 14:
                _context15.prev = 14;
                _context15.t0 = _context15['catch'](0);

                console.error('There was an error fetching the last signal timestmap\n' + _context15.t0);
                return _context15.abrupt('return', null);

              case 18:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this10, [[0, 14]]);
      }))();
    },
    fuelCutCommandFinished: function fuelCutCommandFinished() {
      this.refreshCar();
      if ((0, _keys2.default)(this.$refs).includes('fuelCutHistory')) {
        this.$refs.fuelCutHistory.refreshFirstPage();
      }
    }
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      user: {
        provincia: 'Buenos Aires',
        partido: 'Vicente Lopez',
        barrio: '',
        calle: 'San Lorenzo',
        altura: '1234',
        piso: '',
        puerta: '',
        cp: ''
      }
    };
  },

  props: {
    account: null
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    icon: String
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _freeze = __webpack_require__(17);

var _freeze2 = _interopRequireDefault(_freeze);

var _YesNoModal = __webpack_require__(234);

var _YesNoModal2 = _interopRequireDefault(_YesNoModal);

var _InfoModal = __webpack_require__(229);

var _InfoModal2 = _interopRequireDefault(_InfoModal);

var _vueSimpleSpinner = __webpack_require__(47);

var _vueSimpleSpinner2 = _interopRequireDefault(_vueSimpleSpinner);

var _constants = __webpack_require__(49);

var _thingsService = __webpack_require__(15);

var _thingsService2 = _interopRequireDefault(_thingsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalTypes = (0, _freeze2.default)({
  Activate: 'activate',
  Running: 'running',
  Error: 'error'
});

var query = 'state==\'' + _constants.ThingActionState.Running + '\' AND (action==\'' + _constants.VehicleAction.FuelCutOff + '\' OR action==\'' + _constants.VehicleAction.FuelRestore + '\')&_sort=created_timestamp%2Bdesc';

exports.default = {
  components: {
    YesNoModal: _YesNoModal2.default,
    InfoModal: _InfoModal2.default,
    Spinner: _vueSimpleSpinner2.default
  },

  props: {
    vehicle: Object
  },

  data: function data() {
    return {
      running: false,
      showModal: null,
      pollingInterval: null,
      errorMessage: '',
      modalTypes: modalTypes
    };
  },

  computed: {
    active: function active() {
      return this.vehicle.state.fuel_cut_off;
    },
    activeIcon: function activeIcon() {
      return this.active ? "static/img/fuel-cut.png" : "static/img/fuel-ok.png";
    },
    activeLabel: function activeLabel() {
      if (this.running) {
        return this.active ? "Restaurando..." : "Cortando...";
      }
      return 'Estado';
    },
    showFuelCut: function showFuelCut() {
      return this.vehicle.actions != null && this.vehicle.actions.includes(_constants.VehicleAction.FuelCutOff) && this.vehicle.actions.includes(_constants.VehicleAction.FuelRestore);
    }
  },

  mounted: function mounted() {
    this.checkActionRunning();
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelInterval();
  },


  methods: {
    toggle: function toggle() {
      this.showModal = this.running ? modalTypes.Running : modalTypes.Activate;
    },
    hideModal: function hideModal() {
      this.showModal = null;
      this.errorMessage = '';
    },
    checkActionRunning: function checkActionRunning() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var actions;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _thingsService2.default.getActions(_this.vehicle.id, query);

              case 2:
                actions = _context.sent;

                if (actions.length > 0) {
                  _this.pollAction(actions[0].id);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    executeAction: function executeAction() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var action;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _thingsService2.default.executeAction(_this2.vehicle.id, _this2.active ? _constants.VehicleAction.FuelRestore : _constants.VehicleAction.FuelCutOff, { code: '1234' });

              case 3:
                action = _context2.sent;

                _this2.pollAction(action.id);
                _this2.hideModal();
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                _this2.errorMessage = 'Ha ocurrido un error al intentar ejecutar el comando. Por favor intente de nuevo en unos segundos.';
                _this2.showModal = modalTypes.Error;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    pollAction: function pollAction(executionId) {
      var _this3 = this;

      this.running = true;
      this.pollingInterval = setInterval((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var action;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.running = true;
                _context3.next = 3;
                return _thingsService2.default.getAction(_this3.vehicle.id, executionId);

              case 3:
                action = _context3.sent;

                if (action.state !== _constants.ThingActionState.Running) {
                  setTimeout(function () {
                    if (action.state === _constants.ThingActionState.Finished) {
                      _this3.$emit('execution-finished');
                    }

                    _this3.cancelInterval();
                    _this3.hideModal();

                    if (action.state === _constants.ThingActionState.Error) {
                      _this3.errorMessage = action.result.details;
                      _this3.showModal = modalTypes.Error;
                    }
                  }, 3000);
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      })), 5000);
    },
    cancelInterval: function cancelInterval() {
      this.running = false;
      if (this.pollingInterval != null) {
        clearInterval(this.pollingInterval);
      }
    }
  }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _thingsService = __webpack_require__(15);

var _thingsService2 = _interopRequireDefault(_thingsService);

var _constants = __webpack_require__(49);

var _utils = __webpack_require__(16);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var query = 'action==\'' + _constants.VehicleAction.FuelCutOff + '\' OR action==\'' + _constants.VehicleAction.FuelRestore + '\'&_sort=created_timestamp%2Bdesc';

exports.default = {
  props: {
    vehicle: Object
  },

  data: function data() {
    return {
      currentPage: 1,
      columnsValues: [{
        label: "Comando",
        field: "command",
        sortable: false,
        tdClass: "text-center",
        width: "200px",
        placeholder: "Filtrar por ubicación"
      }, {
        label: "Estado",
        field: "state",
        sortable: false,
        tdClass: "text-center",
        width: "200px",
        placeholder: "Filtrar por ubicación"
      }, {
        label: "Fecha y hora",
        sortable: false,
        field: "datetime",
        type: "number",
        tdClass: "text-center",
        placeholder: "Filtrar por velocidad"
      }],
      currentCommands: []
    };
  },

  mounted: function mounted() {
    this.getHistoryPage(1);
  },


  methods: {
    setPage: function setPage(_ref) {
      var currentPage = _ref.currentPage;

      this.currentPage = currentPage;
      this.getHistoryPage(currentPage);
    },
    refreshFirstPage: function refreshFirstPage() {
      if (this.currentPage === 1) {
        this.getHistoryPage(1);
      }
    },
    getHistoryPage: function getHistoryPage() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var actions;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _thingsService2.default.getActions(_this.vehicle.id, query + '&_limit=10&_page=' + page);

              case 2:
                actions = _context.sent;

                _this.currentCommands = actions.map(function (action) {
                  return {
                    command: action.action === _constants.VehicleAction.FuelCutOff ? "Corte" : "Restauración",
                    datetime: _utils2.default.formatDatetime(action.last_modified_timestamp),
                    state: action.state
                  };
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    positiveText: {
      type: String,
      default: "Aceptar"
    },
    title: {
      type: String
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick: function onClick() {
      this.$emit('pressed-ok');
    }
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    validations: '',
    delay: 0,
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  },

  methods: {
    input_has_changed: function input_has_changed() {
      this.$emit('input-changed', this.name, this.errors.has(this.name));
    },

    tab_pressed: function tab_pressed(event) {
      console.log('press: ' + (0, _stringify2.default)(event));
    }
  },

  mounted: function mounted() {
    if (this.value != '' && this.value != undefined) {
      this.$emit('input-changed', this.name, this.errors.has(this.name));
    }
  },

  watch: {
    value: function value(val) {
      this.input_has_changed();
    }
  }
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(16);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    timestamp: Number,
    address: String,
    refresh: Function
  },

  computed: {
    timeDifference: function timeDifference() {
      return _utils2.default.getTimeDifference(this.timestamp);
    }
  }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    tabs: {
      type: Array,
      default: []
    }
  },

  data: function data() {
    return {
      selectedTab: null
    };
  },

  mounted: function mounted() {
    if (this.tabs.length > 0) {
      this.selectedTab = this.tabs[0];
    }
  },


  methods: {
    selectTab: function selectTab(tab) {
      this.selectedTab = tab;
    }
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    positiveText: {
      type: String,
      default: "Aceptar"
    },
    negativeText: {
      type: String,
      default: "Cancelar"
    },
    title: {
      type: String
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClickPositive: function onClickPositive() {
      this.$emit('pressed-yes');
    },
    onClickNegative: function onClickNegative() {
      this.$emit('pressed-no');
    }
  }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableWithCheckbox = __webpack_require__(237);

var _TableWithCheckbox2 = _interopRequireDefault(_TableWithCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  components: {
    TableWithCheckbox: _TableWithCheckbox2.default
  },

  props: {
    tableData: null,
    tableColumnsTitles: null,
    tableColumnsValues: null,
    title: null,
    subtitle: null
  },

  methods: {
    onSelectChange: function onSelectChange(row) {
      this.$emit('rowSelectedChange', row);
    }
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSimpleSpinner = __webpack_require__(47);

var _vueSimpleSpinner2 = _interopRequireDefault(_vueSimpleSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Spinner: _vueSimpleSpinner2.default
  },

  created: function created() {},


  props: {
    close: null,
    closeFailure: null,
    working: null,
    errorOcurred: null,
    error: null
  },
  data: function data() {
    return {
      large: true,
      spinner_size: 64,
      spinner_line_size: 3,
      spinner_speed: 0.6,
      spinner_spacing: 4,
      spinner_message: "Trabajando",
      spinner_font_size: 13
    };
  },

  methods: {
    closeModal: function closeModal() {
      if (!this.errorOcurred) {
        this.close();
      } else {
        this.closeFailure();
      }
    }
  }
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      selected: null
    };
  },

  props: {
    columnsTitles: Array,
    columnsValues: Array,
    data: Array,
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''

    }
  },
  computed: {
    tableClass: function tableClass() {
      return 'table-' + this.type;
    },
    isPlain: function isPlain() {
      return this.type === 'plain';
    }
  },
  methods: {
    rowSelected: function rowSelected() {
      this.$emit('rowSelectedChange', this.selected);
    },
    itemValue: function itemValue(item, column) {
      var path = column.split('.');

      var itemValue = item[path[0].toLowerCase()];
      var i = 1;
      while (path.length > i) {
        itemValue = itemValue[path[i].toLowerCase()];
        i++;
      }
      return itemValue;
    },
    hasValue: function hasValue(item, column) {
      return this.itemValue(item, column) !== 'undefined';
    }
  }
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(17);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThingActionState = (0, _freeze2.default)({
  Pending: 'pending',
  Running: 'running',
  Canceled: 'canceled',
  Error: 'error',
  Finished: 'finished'
});

exports.default = ThingActionState;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(17);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleAction = (0, _freeze2.default)({
  FuelCutOff: 'fuel_cut_off',
  FuelRestore: 'fuel_restore'
});

exports.default = VehicleAction;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(82);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _globalComponents = __webpack_require__(67);

var _globalComponents2 = _interopRequireDefault(_globalComponents);

var _globalDirectives = __webpack_require__(68);

var _globalDirectives2 = _interopRequireDefault(_globalDirectives);

var _globalMixins = __webpack_require__(69);

var _globalMixins2 = _interopRequireDefault(_globalMixins);

var _App = __webpack_require__(80);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(70);

var _routes2 = _interopRequireDefault(_routes);

var _chartist = __webpack_require__(71);

var _chartist2 = _interopRequireDefault(_chartist);

__webpack_require__(73);

__webpack_require__(75);

__webpack_require__(72);

var _vueResource = __webpack_require__(81);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _veeValidate = __webpack_require__(77);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _es = __webpack_require__(76);

var _es2 = _interopRequireDefault(_es);

var _vueGoodTable = __webpack_require__(79);

var _vueGoodTable2 = _interopRequireDefault(_vueGoodTable);

var _vueClipboard = __webpack_require__(78);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

__webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_globalComponents2.default);
_vue2.default.use(_globalDirectives2.default);
_vue2.default.use(_globalMixins2.default);
_vue2.default.use(_vueResource2.default);

_veeValidate.Validator.localize('es', _es2.default);
_vue2.default.use(_veeValidate2.default, { locale: 'es' });

_vue2.default.use(_vueGoodTable2.default);
_vue2.default.use(_vueClipboard2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default,
  linkActiveClass: 'active'
});

new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  },
  router: router,
  data: {
    Chartist: _chartist2.default
  }
});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Car = undefined;

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Car = function () {
  function Car() {
    (0, _classCallCheck3.default)(this, Car);
  }

  (0, _createClass3.default)(Car, null, [{
    key: 'getNew',
    value: function getNew() {
      return {
        info: {
          make: '',
          model: '',
          domain: '',
          year: '',
          color: '',
          engine_number: '',
          chassis_number: ''
        },
        state: {
          location: {
            coordinates: [-34.5303537853517, -58.497111797332764]
          }
        }
      };
    }
  }]);
  return Car;
}();

exports.Car = Car;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gps = undefined;

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gps = function () {
  function Gps() {
    (0, _classCallCheck3.default)(this, Gps);
  }

  (0, _createClass3.default)(Gps, null, [{
    key: 'getNew',
    value: function getNew() {
      return {
        info: {
          make: '',
          model: '',
          serial_number: '',
          template: ''
        }
      };
    }
  }]);
  return Gps;
}();

exports.Gps = Gps;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gps = __webpack_require__(113);

Object.defineProperty(exports, 'Gps', {
  enumerable: true,
  get: function get() {
    return _gps.Gps;
  }
});

var _car = __webpack_require__(112);

Object.defineProperty(exports, 'Car', {
  enumerable: true,
  get: function get() {
    return _car.Car;
  }
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(32);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(35);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(34);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseGeocodeService = __webpack_require__(30);

var _baseGeocodeService2 = _interopRequireDefault(_baseGeocodeService);

var _nominatimGeocodeService = __webpack_require__(117);

var _nominatimGeocodeService2 = _interopRequireDefault(_nominatimGeocodeService);

var _clickgoGeocodeService = __webpack_require__(116);

var _clickgoGeocodeService2 = _interopRequireDefault(_clickgoGeocodeService);

var _geocodeProvider = __webpack_require__(52);

var _geocodeProvider2 = _interopRequireDefault(_geocodeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeocodeService = function (_BaseGeocodeService) {
  (0, _inherits3.default)(GeocodeService, _BaseGeocodeService);

  function GeocodeService(provider) {
    (0, _classCallCheck3.default)(this, GeocodeService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GeocodeService.__proto__ || (0, _getPrototypeOf2.default)(GeocodeService)).call(this));

    _this._geocodeService = null;
    _this.setProvider(provider);
    return _this;
  }

  (0, _createClass3.default)(GeocodeService, [{
    key: 'reverseGeocode',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(latitude, longitude) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this._geocodeService.reverseGeocode(latitude, longitude));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reverseGeocode(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return reverseGeocode;
    }()
  }, {
    key: 'setProvider',
    value: function setProvider(provider) {
      this.provider = provider;
      switch (provider) {
        case _geocodeProvider2.default.Nominatim:
          this._geocodeService = _nominatimGeocodeService2.default;
          break;

        case _geocodeProvider2.default.ClickGo:
          this._geocodeService = _clickgoGeocodeService2.default;
          break;
        default:
          this.provider = _geocodeProvider2.default.ClickGo;
          this._geocodeService = _clickgoGeocodeService2.default;
          break;
      }
    }
  }, {
    key: 'getProvider',
    value: function getProvider() {
      return this.provider;
    }
  }]);
  return GeocodeService;
}(_baseGeocodeService2.default);

var geocodeService = new GeocodeService();
exports.default = geocodeService;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(32);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(35);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(34);

var _inherits3 = _interopRequireDefault(_inherits2);

var _address = __webpack_require__(50);

var _address2 = _interopRequireDefault(_address);

var _baseGeocodeService = __webpack_require__(30);

var _baseGeocodeService2 = _interopRequireDefault(_baseGeocodeService);

var _server_config = __webpack_require__(14);

var _server_config2 = _interopRequireDefault(_server_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_HEADERS = {
  "Content-Type": "application/json; charset=utf-8"
};

var ClickGoGeocodeService = function (_BaseGeocodeService) {
  (0, _inherits3.default)(ClickGoGeocodeService, _BaseGeocodeService);

  function ClickGoGeocodeService(serviceUrl, serviceToken) {
    (0, _classCallCheck3.default)(this, ClickGoGeocodeService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ClickGoGeocodeService.__proto__ || (0, _getPrototypeOf2.default)(ClickGoGeocodeService)).call(this));

    _this.serviceUrl = serviceUrl;
    _this.serviceToken = serviceToken;
    return _this;
  }

  (0, _createClass3.default)(ClickGoGeocodeService, [{
    key: 'reverseGeocode',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(latitude, longitude) {
        var requestBody, result, addressFields, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestBody = {
                  "geoRef": {
                    "token": this.serviceToken,
                    "coordenadas": [{
                      "idPosicion": 1,
                      "latitud": latitude,
                      "longitud": longitude
                    }]
                  }
                };
                _context.next = 3;
                return fetch(this.serviceUrl, { method: 'POST', headers: REQUEST_HEADERS, body: (0, _stringify2.default)(requestBody) }).then(function (response) {
                  return response.json();
                }).catch(function (error) {
                  throw new Error('There was an error geocoding (' + latitude + ', ' + longitude + ')\n ' + error);
                });

              case 3:
                result = _context.sent;

                if (!(result.GetGeoRefByCoordsResult.error !== '')) {
                  _context.next = 6;
                  break;
                }

                throw new Error('There was an error geocoding (' + latitude + ', ' + longitude + ')\n ' + result.GetGeoRefByCoordsResult.error);

              case 6:
                if (!(result.GetGeoRefByCoordsResult.items.length === 0)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', null);

              case 8:
                addressFields = result.GetGeoRefByCoordsResult.items[0];
                response = new _address2.default.Builder().setNumber(addressFields.CP_Desde + '/' + addressFields.CP_Hasta).setStreet(addressFields.callePrincipal).setNeighbourhood(addressFields.barrioCapFed ? addressFields.barrioCapFed : addressFields.depto).setCity(addressFields.localidad).setState(addressFields.provincia).setCountry(addressFields.pais).setFullAddress(addressFields.literal).build();
                return _context.abrupt('return', response);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reverseGeocode(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return reverseGeocode;
    }()
  }]);
  return ClickGoGeocodeService;
}(_baseGeocodeService2.default);

var geocodeService = new ClickGoGeocodeService(_server_config2.default.clickgo_url, _server_config2.default.clickgo_token);
exports.default = geocodeService;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(4);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(3);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(32);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(35);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(34);

var _inherits3 = _interopRequireDefault(_inherits2);

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _address = __webpack_require__(50);

var _address2 = _interopRequireDefault(_address);

var _baseGeocodeService = __webpack_require__(30);

var _baseGeocodeService2 = _interopRequireDefault(_baseGeocodeService);

var _responseCacher = __webpack_require__(119);

var _responseCacher2 = _interopRequireDefault(_responseCacher);

var _server_config = __webpack_require__(14);

var _server_config2 = _interopRequireDefault(_server_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CACHE_RETRIEVALS_BEFORE_CLEAN = 1000;
var KEEP_CACHED_MS = 900000;
var NominatimGeocodeService = function (_BaseGeocodeService) {
  (0, _inherits3.default)(NominatimGeocodeService, _BaseGeocodeService);

  function NominatimGeocodeService(serviceUrl) {
    (0, _classCallCheck3.default)(this, NominatimGeocodeService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NominatimGeocodeService.__proto__ || (0, _getPrototypeOf2.default)(NominatimGeocodeService)).call(this));

    _this.serviceUrl = serviceUrl;
    _this.cache = new _responseCacher2.default(CACHE_RETRIEVALS_BEFORE_CLEAN, KEEP_CACHED_MS);
    return _this;
  }

  (0, _createClass3.default)(NominatimGeocodeService, [{
    key: 'reverseGeocode',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(latitude, longitude) {
        var key, result, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = '' + latitude + longitude;

                if (!this.cache.isCached(key)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', this.cache.getValue(key));

              case 3:
                _context.next = 5;
                return _vue2.default.http.get(this.serviceUrl + '/reverse', {
                  responseType: 'text',
                  params: {
                    lat: latitude,
                    lon: longitude,
                    format: 'json',
                    zoom: 18,
                    polygon: 1
                  }
                });

              case 5:
                result = _context.sent.body;
                response = new _address2.default.Builder().setNumber(result.address.house_number).setStreet(result.address.road).setNeighbourhood(result.address.suburb).setCity('city' in result.address ? result.address.city : result.address.town).setState(result.address.state).setCountry(result.address.country).build();


                this.cache.setValue(key, response);

                return _context.abrupt('return', response);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reverseGeocode(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return reverseGeocode;
    }()
  }]);
  return NominatimGeocodeService;
}(_baseGeocodeService2.default);

var geocodeService = new NominatimGeocodeService(_server_config2.default.nominatim_url);
exports.default = geocodeService;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeocodeService = undefined;

var _geocoding = __webpack_require__(53);

var _geocoding2 = _interopRequireDefault(_geocoding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GeocodeService = _geocoding2.default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(18);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(8);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponseCacher = function () {
  function ResponseCacher(cacheRetrievalsBeforeClean, keepCachedMs) {
    (0, _classCallCheck3.default)(this, ResponseCacher);

    this.cachedResponses = {};
    this.retrievalCount = 0;
    this.cacheRetrievalsBeforeClean = cacheRetrievalsBeforeClean != null ? cacheRetrievalsBeforeClean : 1000;
    this.keepCachedMs = keepCachedMs != null ? keepCachedMs : 900000;
  }

  (0, _createClass3.default)(ResponseCacher, [{
    key: "isCached",
    value: function isCached(key) {
      return key in this.cachedResponses;
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      this.cachedResponses[key].timestamp = new Date().getTime();
      this.retrievalCount += 1;
      if (this.retrievalCount >= this.cacheRetrievalsBeforeClean) {
        this.cleanCache();
        this.retrievalCount = 0;
      }
      return this.cachedResponses[key].value;
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      this.cachedResponses[key] = {
        value: value,
        timestamp: new Date().getTime()
      };
    }
  }, {
    key: "cleanCache",
    value: function cleanCache() {
      var _this = this;

      var now = new Date().getTime();
      var oldAddresses = (0, _keys2.default)(this.cachedResponses).filter(function (key) {
        return now - _this.cachedResponses[key].timestamp > _this.keepCachedMs;
      });
      oldAddresses.forEach(function (key) {
        return delete _this.cachedResponses[key];
      });
    }
  }]);
  return ResponseCacher;
}();

exports.default = ResponseCacher;

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-50542d54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  "data-v-355a4aa2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  "data-v-109115e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-859976ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-c924a5c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  "data-v-406852ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  "data-v-795a2c91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  "data-v-f2bd7450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  "data-v-0ea1a40a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 date-range"
  }, [_vm._v("\n      Rango de búsqueda:\n      "), _c('date-picker', {
    attrs: {
      "format": "DD/MM/YYYY",
      "lang": "es",
      "shortcuts": false,
      "range": "",
      "confirm": ""
    },
    on: {
      "clear": _vm.clearDates,
      "confirm": _vm.datesChanged
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 geolocalization-provider"
  }, [_c('span', [_vm._v("Proveedor de geolocalizacion:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProvider),
      expression: "selectedProvider"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProvider = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeGeocodingProvider]
    }
  }, _vm._l((_vm.geocodeProviders), function(provider) {
    return _c('option', {
      key: provider.value,
      domProps: {
        "value": provider.value
      }
    }, [_vm._v(_vm._s(provider.name))])
  }), 0)])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsValues,
      "rows": _vm.currentSignals,
      "line-numbers": true,
      "styleClass": "vgt-table bordered",
      "pagination-options": {
        enabled: true,
        perPage: '15',
        perPageDropdown: [15],
        mode: 'records',
        rowsPerPageLabel: 'Reportes por página',
        ofLabel: 'de',
        allLabel: 'Todas',
        prevLabel: 'Anterior',
        nextLabel: 'Siguiente'
      }
    },
    on: {
      "on-row-click": _vm.showRow
    }
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("No existen resultados")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group label-floating"
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations),
      expression: "validations"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has(_vm.name),
      'form-control': true,
      'border-input': true
    },
    attrs: {
      "data-vv-delay": _vm.delay
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.input_has_changed.apply(null, arguments)
      },
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "change": _vm.input_has_changed
    }
  }, 'input', _vm.$props, false)), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.name)),
      expression: "errors.has(name)"
    }],
    staticClass: "form-group__message help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first(_vm.name)) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    class: {
      'modal-container  small': !_vm.large,
      'modal-container large': _vm.large
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [(_vm.working) ? _c('spinner', {
      attrs: {
        "size": _vm.spinner_size,
        "line-size": _vm.spinner_line_size,
        "speed": _vm.spinner_speed,
        "spacing": _vm.spinner_spacing,
        "message": _vm.spinner_message,
        "font-size": _vm.spinner_font_size
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.working && !_vm.errorOcurred) ? _c('h1', [_vm._v("Finalizado "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done")])]) : _vm._e(), _vm._v(" "), (!_vm.working && _vm.errorOcurred) ? _c('h1', [_vm._v("Ocurrio un error "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("error_outline")])]) : _vm._e(), _vm._v(" "), (!_vm.working && _vm.errorOcurred) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(_vm.error != null) ? _c('span', {
      staticClass: "form-group__message help is-danger"
    }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]) : _vm._e()])]) : _vm._e()]
  })], 2), _vm._v(" "), (!_vm.working) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "role": "group",
        "aria-label": "Basic example"
      }
    }, [_c('button', {
      staticClass: "spacedBtn btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Cerrar")])])]
  })], 2) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFuelCut) ? _c('div', {
    staticClass: "fuel-cut-control"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.active
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n        Cortar suministro\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#83c554"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.active
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n        Restablecer suministro\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-left": "1px solid grey",
      "margin": "0 10px",
      "height": "70px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state-container"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.activeLabel) + " ")]), _vm._v(" "), (_vm.running) ? _c('spinner') : _c('img', {
    attrs: {
      "width": "64px",
      "src": _vm.activeIcon,
      "alt": "fuel"
    }
  })], 1)])]), _vm._v(" "), _c('yes-no-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Activate,
      "title": ("¿Está seguro que desea " + (this.active ? 'desactivar' : 'activar') + " el corte de combustible?")
    },
    on: {
      "pressed-no": function($event) {
        return _vm.hideModal()
      },
      "pressed-yes": function($event) {
        return _vm.executeAction()
      }
    }
  }, [_c('p', [_vm._v(" De hacerlo, el vehículo "), _c('b', [_vm._v(_vm._s(this.active ? 'podrá volver a' : 'no podrá'))]), _vm._v(" circular. ")])]), _vm._v(" "), _c('info-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Running,
      "title": ((this.active ? 'Desactivando' : 'Activando') + " corte de combustible...")
    },
    on: {
      "pressed-ok": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_c('spinner')], 1), _vm._v(" "), _c('info-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Error,
      "title": ("Ha ocurrido un error al " + (this.active ? 'desactivat' : 'activar') + " el corte de combustible...")
    },
    on: {
      "pressed-ok": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_c('h4', [_vm._v("Corte de combustible")])])
}]}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-5"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enable_map_link
    }
  }, [_vm._v("Generar enlace")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-md-offset-2"
  }, [(_vm.showLink) ? _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": _vm.mapLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.mapLink))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.showLink) ? _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.mapLink),
      expression: "mapLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "type": "button",
      "data-toggle": "popover",
      "data-container": "body",
      "data-placement": "right",
      "data-content": "Copiado"
    }
  }, [_vm._v("Copiar")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h4', {
    staticClass: "title"
  })])])])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-8 col-md-offset-2 col-sm-offset-2"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "password",
      "label": "Clave"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-4"
  }, [(_vm.error_message) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.authenticate()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-offset-5"
  }, [_c('img', {
    staticClass: "rounded mx-auto d-block",
    attrs: {
      "id": "login-img",
      "src": __webpack_require__(211),
      "alt": "LoJack Logo"
    }
  })])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container col-md-8 col-sm-8 col-md-offset-2 col-sm-offset-2"
  }, [_c('search-car', {
    on: {
      "input-changed": _vm.selectCar,
      "reset-view": _vm.reset_view,
      "localizar": _vm.localizar_click
    }
  }), _vm._v(" "), (_vm.isProcessing) ? _c('spinner', {
    attrs: {
      "size": 50,
      "line-size": 3,
      "speed": 0.6,
      "line-fg-color": 'magenta',
      "spacing": 6,
      "message": 'Procesando información...',
      "font-size": 18,
      "text-fg-color": '#07088E'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_tracking) ? _c('div', [_c('change-car', {
    attrs: {
      "car": _vm.car,
      "gps": _vm.gps,
      "error-gps": _vm.errorGps,
      "account": _vm.account
    },
    on: {
      "car-change": _vm.carChange,
      "account-change": _vm.accountChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "command-panel"
  }, [(_vm.lastPosition) ? _c('last-position-table', {
    attrs: {
      "timestamp": _vm.lastPosition.timestamp,
      "address": _vm.lastPosition.address,
      "refresh": _vm.refreshCar
    }
  }) : _vm._e(), _vm._v(" "), _c('fuel-cut', {
    attrs: {
      "vehicle": _vm.car
    },
    on: {
      "execution-finished": function($event) {
        return _vm.fuelCutCommandFinished()
      }
    }
  })], 1), _vm._v(" "), _c('maps', {
    attrs: {
      "id": "map",
      "last-car-location": _vm.lastPosition,
      "signals": _vm.currentSignals,
      "markerFocused": _vm.markerToFocus,
      "freshSignals": _vm.finalSignals
    }
  }), _vm._v(" "), _c('tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tabs": ['Ultimos reportes', 'Comandos de corte: Log']
    }
  }, [_c('location-table', {
    attrs: {
      "slot": "Ultimos reportes",
      "car": _vm.car,
      "current-signals": _vm.currentSignals,
      "rows-per-page": _vm.rowsPerPageTrack
    },
    on: {
      "focus-location": _vm.focusLocation,
      "page-change": _vm.pageChange,
      "clear-dates": _vm.clearDates,
      "change-dates": _vm.changeDates,
      "change-geocode-provider": _vm.changeGeolocalizationProvider
    },
    slot: "Ultimos reportes"
  }), _vm._v(" "), _c('fuel-cut-history', {
    ref: "fuelCutHistory",
    attrs: {
      "slot": "Comandos de corte: Log",
      "vehicle": _vm.car
    },
    slot: "Comandos de corte: Log"
  })], 1), _vm._v(" "), _c('map-link', {
    attrs: {
      "map-link": _vm.mapLink,
      "show-link": _vm.showLink,
      "copying": false
    },
    on: {
      "enable-map-link": _vm.enable_map_link
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropDown),
      expression: "closeDropDown"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpen
    },
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    }
  }, [_vm._t("title", function() {
    return [_c('span', [_vm._v(_vm._s(_vm.title))])]
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_c('h4', [_vm._v("Ultima posición reportada al momento de la búsqueda")]), _vm._v(" "), _c('div', {
    staticClass: "actions-container"
  }, [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Refrescar")]), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Tiempo")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("Hace " + _vm.timeDifference)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Dirección")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.address))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.car.info.make) + " " + _vm._s(_vm.car.info.model) + " " + _vm._s(_vm.car.info.color))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.account.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(!_vm.show) ? _c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showInstance
    }
  }, [_vm._v("expand_more")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showInstance
    }
  }, [_vm._v("expand_less")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('span', [_c('b', [_vm._v("Año:")]), _vm._v("\n            " + _vm._s(_vm.car.info.year) + "\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Patente:")]), _vm._v("\n            " + _vm._s(_vm.car.info.domain) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.account.identification_type) + ":")]), _vm._v("\n            " + _vm._s(_vm.account.identification_number) + "\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasPhones) ? _c('span', [_c('b', [_vm._v("Teléfono:")]), _vm._v("\n            " + _vm._s(_vm.account.phones[0].number) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('car-props', {
    attrs: {
      "car": _vm.myCopyCar
    },
    on: {
      "input-changed": _vm.input_changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('magenta-address-form', {
    attrs: {
      "home": _vm.myCopyAccount
    },
    on: {
      "input-changed": _vm.input_changed
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.errorGps) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.errorGps) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-10"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Información del GPS")]), _vm._v(" "), _c('g-p-s-form', {
    attrs: {
      "editable": false,
      "gps": _vm.gps.info
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.show) ? _c('div', {
    staticClass: "col-md-offset-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabledGuardar
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Guardar")])]) : _vm._e()])])]), _vm._v(" "), (_vm.showModal) ? _c('loader-modal', {
    attrs: {
      "working": _vm.modalWorking,
      "error-ocurred": _vm.errorOcurred,
      "error": _vm.error,
      "close": _vm.closeSuccess,
      "close-failure": _vm.closeFailure
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-offset-1"
  }, [_c('h4', [_c('span', {
    staticClass: "form-group__message help is-danger"
  }, [_vm._v("Se ha producido un error obteniendo el gps, por favor intente nuevamente.")])])])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta"
    }
  }, [_c('h4', [_vm._v("Busqueda Vehículo")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showInstance
    }
  }, [_vm._v(_vm._s(_vm.show ? 'expand_less' : 'expand_more'))])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "searchbox-container"
  }, [_c('div', {
    staticClass: "searchbox"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|numeric|max:11|min:7",
      "name": "número",
      "label": "Número",
      "delay": "0"
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.docSearchCriteria.identification_number),
      callback: function($$v) {
        _vm.$set(_vm.docSearchCriteria, "identification_number", $$v)
      },
      expression: "docSearchCriteria.identification_number"
    }
  }), _vm._v(" "), _c('drop-down', {
    staticStyle: {
      "min-width": "105px",
      "margin-left": "10px"
    },
    attrs: {
      "title": _vm.ddTitleDoc
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "slot": "title",
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleDoc))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "button"
    }
  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', _vm._l((_vm.types), function(docType) {
    return _c('a', {
      key: docType,
      on: {
        "click": function($event) {
          return _vm.putDoc(docType)
        }
      }
    }, [_vm._v(_vm._s(docType))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSearchDoc
    },
    on: {
      "click": _vm.buscarDocumento
    }
  }, [_vm._v("Buscar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "searchbox"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|alpha_num",
      "name": "patente",
      "label": "Patente",
      "delay": "0"
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.domain),
      callback: function($$v) {
        _vm.domain = $$v
      },
      expression: "domain"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSearchDomain
    },
    on: {
      "click": _vm.buscarPatente
    }
  }, [_vm._v("Buscar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "searchbox"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|alpha_num",
      "name": "serial",
      "label": "Serial",
      "delay": "0"
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.serial),
      callback: function($$v) {
        _vm.serial = $$v
      },
      expression: "serial"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSearchSerial
    },
    on: {
      "click": _vm.searchSerial
    }
  }, [_vm._v("Buscar")])], 1)]), _vm._v(" "), _c('item-list', {
    attrs: {
      "table-columns-titles": _vm.tableColumnsTitles,
      "table-columns-values": _vm.tableColumnsValues,
      "table-data": _vm.searchResult
    },
    on: {
      "rowSelectedChange": _vm.onSelectChange
    }
  }), _vm._v(" "), (_vm.searchResult != null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.carSelected == null
    },
    on: {
      "click": _vm.localizar
    }
  }, [_vm._v("\n      Localizar\n    ")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table-with-checkbox', {
    attrs: {
      "title": _vm.title,
      "sub-title": _vm.subtitle,
      "data": _vm.tableData,
      "columns-titles": _vm.tableColumnsTitles,
      "columns-values": _vm.tableColumnsValues
    },
    on: {
      "rowSelectedChange": _vm.onSelectChange
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab,
      class: {
        active: tab === _vm.selectedTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_c('a', [_vm._v(" " + _vm._s(tab) + " ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "none"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._t(_vm.selectedTab, function() {
    return [_vm._v("\n          Empty tab\n      ")]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.flex !== undefined) ? _c('div', [(!_vm.editable) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Tecnología",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.flex.tecnology),
      callback: function($$v) {
        _vm.$set(_vm.flex, "tecnology", $$v)
      },
      expression: "flex.tecnology"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleTec
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleTec))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.putTec('GPS')
      }
    }
  }, [_vm._v("GPS")])])])], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|regex:^([0-9A-Za-z]+)$",
      "name": "numero de serie",
      "label": "Número de Serie",
      "delay": "0",
      "disabled": !_vm.editable,
      "value": _vm.gps.serial_number
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.gps.serial_number),
      callback: function($$v) {
        _vm.$set(_vm.gps, "serial_number", $$v)
      },
      expression: "gps.serial_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|regex:^([0-9A-Za-z]+)$",
      "name": "template",
      "label": "Template",
      "delay": "0",
      "disabled": !_vm.editable,
      "value": _vm.gps.template
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.gps.template),
      callback: function($$v) {
        _vm.$set(_vm.gps, "template", $$v)
      },
      expression: "gps.template"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Marca",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.gps.make),
      callback: function($$v) {
        _vm.$set(_vm.gps, "make", $$v)
      },
      expression: "gps.make"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleMake
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleMake))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.putMake('Queclink');
        _vm.updateModel('queclink')
      }
    }
  }, [_vm._v("Queclink")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.putMake('Calamp');
        _vm.updateModel('calamp')
      }
    }
  }, [_vm._v("Calamp")])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Modelo",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.gps.model),
      callback: function($$v) {
        _vm.$set(_vm.gps, "model", $$v)
      },
      expression: "gps.model"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleModel
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleModel))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _vm._l((_vm.queclinkModels), function(model) {
    return (_vm.ddTitleMake === 'Queclink') ? _c('li', {
      key: model.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.putModel(model)
        }
      }
    }, [_vm._v(_vm._s(model))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.calampModels), function(model) {
    return (_vm.ddTitleMake === 'Calamp') ? _c('li', {
      key: model.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.putModel(model)
        }
      }
    }, [_vm._v(_vm._s(model))])]) : _vm._e()
  })], 2)], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.home.label !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Nombre",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.label),
      callback: function($$v) {
        _vm.$set(_vm.home, "label", $$v)
      },
      expression: "home.label"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Direccion",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.address_line1),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "address_line1", $$v)
      },
      expression: "home.address.address_line1"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Datos adicionales",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.address_line2),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "address_line2", $$v)
      },
      expression: "home.address.address_line2"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Ciudad",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.city),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "city", $$v)
      },
      expression: "home.address.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Provincia",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.state),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "state", $$v)
      },
      expression: "home.address.state"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "País",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.country),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "country", $$v)
      },
      expression: "home.address.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "numeric",
      "name": "codigo postal",
      "label": "Código Postal",
      "delay": "0"
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.home.address.postal_code),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "postal_code", $$v)
      },
      expression: "home.address.postal_code"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Marca"
    },
    model: {
      value: (_vm.car.info.make),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "make", $$v)
      },
      expression: "car.info.make"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Modelo"
    },
    model: {
      value: (_vm.car.info.model),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "model", $$v)
      },
      expression: "car.info.model"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Dominio",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.domain),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "domain", $$v)
      },
      expression: "car.info.domain"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "numeric",
      "name": "año",
      "label": "Año",
      "delay": "0",
      "disabled": true
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.car.info.year),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "year", $$v)
      },
      expression: "car.info.year"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Color"
    },
    model: {
      value: (_vm.car.info.color),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "color", $$v)
      },
      expression: "car.info.color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Motor",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.engine_number),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "engine_number", $$v)
      },
      expression: "car.info.engine_number"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Chasis",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.chassis_number),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "chassis_number", $$v)
      },
      expression: "car.info.chassis_number"
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-plain': _vm.isPlain
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', [_c('th'), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', [_vm._v(_vm._s(column))])
  })], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filaSelect),
        expression: "filaSelect"
      }],
      staticClass: "form-check-input",
      attrs: {
        "name": "radio",
        "type": "radio"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.filaSelect, item)
      },
      on: {
        "change": function($event) {
          _vm.filaSelect = item
        }
      }
    })]), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return (_vm.hasValue(item, column)) ? _c('td', [_vm._v(_vm._s(_vm.itemValue(item, column)))]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.localizar
    }
  }, [_vm._v("Localizar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  })])])
}]}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsValues,
      "rows": _vm.currentCommands,
      "pagination-options": {
        enabled: true,
        perPage: '10',
        perPageDropdown: [10],
        mode: 'records',
        rowsPerPageLabel: 'Reportes por página',
        ofLabel: 'de',
        allLabel: 'Todas',
        prevLabel: 'Anterior',
        nextLabel: 'Siguiente'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("No existen resultados")])])
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group label-floating"
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Provincia"
    },
    model: {
      value: (_vm.user.provincia),
      callback: function($$v) {
        _vm.$set(_vm.user, "provincia", $$v)
      },
      expression: "user.provincia"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Partido"
    },
    model: {
      value: (_vm.user.partido),
      callback: function($$v) {
        _vm.$set(_vm.user, "partido", $$v)
      },
      expression: "user.partido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Barrio"
    },
    model: {
      value: (_vm.user.barrio),
      callback: function($$v) {
        _vm.$set(_vm.user, "barrio", $$v)
      },
      expression: "user.barrio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Calle"
    },
    model: {
      value: (_vm.user.calle),
      callback: function($$v) {
        _vm.$set(_vm.user, "calle", $$v)
      },
      expression: "user.calle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "Altura"
    },
    model: {
      value: (_vm.user.altura),
      callback: function($$v) {
        _vm.$set(_vm.user, "altura", $$v)
      },
      expression: "user.altura"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Piso"
    },
    model: {
      value: (_vm.user.piso),
      callback: function($$v) {
        _vm.$set(_vm.user, "piso", $$v)
      },
      expression: "user.piso"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Puerta"
    },
    model: {
      value: (_vm.user.puerta),
      callback: function($$v) {
        _vm.$set(_vm.user, "puerta", $$v)
      },
      expression: "user.puerta"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "C.P."
    },
    model: {
      value: (_vm.user.cp),
      callback: function($$v) {
        _vm.$set(_vm.user, "cp", $$v)
      },
      expression: "user.cp"
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'fullMap': !_vm.normalMapSize
    },
    attrs: {
      "id": "map"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "container"
    }
  }, [_c('router-view', {
    attrs: {
      "id": "view"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container small"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.positiveText) + " ")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Dashboard")])], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "footer-demo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Oops! It seems that this page does not exist.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n        © 2017, made with\n        "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by Material admin\n      ")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-plain': _vm.isPlain
    }
  }, [(_vm.data != null) ? _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_vm._t("header", function() {
    return [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
      staticClass: "category"
    }, [_vm._v(_vm._s(_vm.subTitle))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.data != null && _vm.data.length > 0) ? _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    class: _vm.tableClass
  }, [_c('thead', [_c('th'), _vm._v(" "), _vm._l((_vm.columnsTitles), function(colTitle) {
    return _c('th', [_vm._v(_vm._s(colTitle))])
  })], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      staticClass: "form-check-input",
      attrs: {
        "name": "radio",
        "type": "radio"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.selected, item)
      },
      on: {
        "change": [function($event) {
          _vm.selected = item
        }, _vm.rowSelected]
      }
    })]), _vm._v(" "), _vm._l((_vm.columnsValues), function(attributeName) {
      return (_vm.hasValue(item, attributeName)) ? _c('td', [_vm._v(_vm._s(_vm.itemValue(item, attributeName)))]) : _vm._e()
    })], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.data != null && _vm.data.length == 0) ? _c('div', [_c('br'), _c('h4', {
    attrs: {
      "id": "no_data"
    }
  }, [_vm._v("No hay resultados para mostrar")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container small"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.onClickNegative()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.negativeText) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.onClickPositive()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.positiveText) + " ")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[111]);


// WEBPACK FOOTER //
// static/js/app.65b3b65ad0189cb858a4.js